/* eslint-disable eqeqeq */
// import {formUtil} from '../form'
import {getDicData, getConfig, getGridData, getDataByApi, getSqlDicData, getTreeData} from '@/api/form-render';
import {mapGetters, mapMutations} from 'vuex';
import {EVENT_TYPE, API_RUN_TYPE} from '../../../public/js/const';
import {FUN_DATA, funUtil} from '../util';
import excel from '@/utils/excel';

import {getUUID} from '../../../utils/uuid';
export const mixin = {
  name: 'edit-table',
  data: function () {
    return {
      rowKey: 'id', // 树表时指定
      // 获取row的key值
      getRowKeys (row) {
        return row.id;
      },
      showPageBar:false,
      dataList:[],
      pageSize: 100,
      pageIndex: 1,
      pageCount: 0,
      totalCount: 0,
      currentRow: null, // 当前选中行
      // dicMap: {},
      columnTitleMap: {},
      columnsMap: {},
      summaryData: {}, // 表格合计数据
      onlyMainExpression:{}, // 只有主表字段出发的
      mainExpression: {}, // 主表字段触发计算公式
      mainShowCondition: {}, // 主表字段出发计算显示隐藏
      expression: {}, // 计算公式
      summaryColumns: {}, // 合计列
      showSummary: false, // 是否显示合计
      selectTableIndex: -1, // 表格选中的行数
      selectTableRow: null, // 表格选中的行
      selectFormKey: '', // 弹框选择，关联表单的formKey
      selectFormTitle: '', // 弹框选择，表单title
      selectFormConfig: {}, // 选择弹出框的配置
      selectFormVisible: false,
      selection: [], // checkbox行
      subFormConfig: undefined,
      columns: [], // 列
      topBar: [],
      isTree: false, // 是否树表
      queryParams: {},
      require: false,
      validMessage: '',
      subSelectMemberModels: {// 人员控件
        form: {},
        isShow: false,
        selectList: [],
        callBack: this.subMemberCallBack,
        radioSelectFlags: false
      },
      selectMemberModels: {// 人员控件
        form: {},
        isShow: false,
        selectList: [],
        callBack: this.memberCallBack,
        radioSelectFlags: false
      },
      selectQuertersModels: {// 部门控件
        isShow: false,
        form: {},
        selectList: [],
        callBack: this.quertersCallBack,
        radioSelectFlags: false
      },
      showTopNewButton: true,
      showTopDeleteButton: true,
      showCellNewButton: true,
      showCellDeleteButton: true,
      openDialogTitle: '', // 弹框打开表单的标题
      openDialogConfig: {}, // 弹框打开表单的配置
      openDialogVueName: '', // 弹框打开表单的配置
      openDialogWidth: 900,
      openDialogHeight: 700,
      openDialogVisible: false, // 弹框打开页面openType=1
      selectExcelVisible: false,
      selectFormSingleSelect: false, // 选择弹框选择数据
      selectFormColumn: null, // 行内弹框绑定的列
      excelList: [],
      moreColumns: [],
      uploadLoading: false,
      loading: false,
      ifFormEditRender: false, // 是否表单编辑时第一次渲染
      file: null,
      uploadConfig: {
        limit: 10,
        limitSize: 50048576,
        // listType: 'picture-card',
        readOnly: false,
        xtype: 'test',
        accept: '.xlsx,.xls',
        acceptMsg: '只能传xls/xlsx格式文件'
      },
      uploadDialogVisible: false, // 明细表上传框
      uploadDialogConfig: { // 明细表上传时对应的列和行
        column: null,
        row: null // 当前操作列
      },
      showConditionData: {}, // 字段显示条件数据，优先级最高，超过流程过程控制
      excelData: [],
      excelModal: null,
      importErrorMsg:'',
      importErrorData:[],
      ocrConfig: null, // ocr配置
      ocrInvoiceVisible: false // 发票识别
    };
  },
  props: {
    config: {
      type: Object,
      default: function () {
        return {};
      }
    },
    authsMap: {
      type: Object,
      default: function () {
        return {};
      }
    },
    level: { // 默认明细表的层级，一般只有一层，只有询价比价单是两层明细
      type: Number,
      default: function () {
        return 1;
      }
    },
    mainData: {
      type: Object,
      default: function () {
        return {};
      }
    },
    readOnly: {
      type: Boolean,
      default: function () {
        return false;
      }
    }
  },
  computed: {
    ...mapGetters([
      'getFormConfig'
    ]),
    compputeLineNum(){
      return function (index) {
        return (this.pageIndex-1)*this.pageSize+index+1;
      };
    },
    dicValue () { // 数据字典label
      return function (column, value) {
        // console.info(column)
        // console.info(JSON.stringify(column))
        //console.log(column.title+'------dicValue---'+value+'-----',column,column.options, value);
        if (column && column.options) {
          // console.info('---dicMap[column.columnName]---'+JSON.stringify(this.dicMap[column.columnName]))
          // console.info(value+'-------'+this.dicMap[column.columnName][value+''])
          if (column.multiple === 1 && value) {
            if (typeof value === 'string') {
              value = value.split(',');
            }
            let str = '';
            value.forEach(v => {
              let e = column.options.find(item => {
                return item.value === v;
              });
              str = e ? str += e.name + ',' : str;
            });
            if (str) {
              value = str.slice(0, str.length - 1);
            }
          } else {
            let e = column.options.find(item => {
              //console.log(value+'----'+(item.value === value)+'-----'+item.value,(item.value),(typeof value))
              if(column.javaType === 'number'){
                return Number(item.value) === Number(value);
              }else{
                let str1 = item.value+'';
                let str2 = value+'';
                return str1 === str2;
              }

            });
            // console.log('--------------',e)
            value = e ? e.name : value;
          }
        }
        return value || '';
      };
    },
    formatDate () {
      return function (column, value) {
        let format = 'yyyy-MM-dd';
        if (column.widgetType === 'select-time') {
          format = 'HH:mm:ss';
        } else if (column.widgetType === 'select-date-time') {
          format = 'yyyy-MM-dd hh:mm:ss';
        }
        // console.log('-----formatDate-------',value,typeof value, format)
        if (typeof value === 'number') {
          let date = new Date(value);
          return date.format(format);
        } else if (typeof value === 'string') {
          if (value.indexOf('T') > -1) {
            return value.substring(0, 10);
          } else {
            try {
              if (value.indexOf(':') > -1) {
                return value;
              } else {
                let num = Number(value);
                let date = new Date(num);
                return date.format(format);
              }
            } catch (e) {
              return value;
            }
          }
        }
      };
    },
    // 判断字段是否显示
    formColumnHidden () {
      return function (column) {
        // 优先隐藏条件
        if (this.showConditionData && this.showConditionData[column.columnName] != undefined) {
          // console.log('---------'+column.columnName+'---------'+this.showConditionData[column.columnName])
          if (this.showConditionData[column.columnName] == false) {
            column.visible = false;
            return true;
          } else {
            column.visible = true;
            return false;
          }
        }

        // 优先判断流程配置权限
        if (this.authsMap && this.authsMap[this.config.id]) {
          if (this.authsMap[this.config.id][column.columnName] == 1) {
            column.visible = true;
            return false;
          } if (this.authsMap[this.config.id][column.columnName] == 2) {
            column.visible = true;
            return false;
          } else if (this.authsMap[this.config.id][column.columnName] == 3) {
            column.visible = false;
            return true;
          } else if (this.authsMap[this.config.id][column.columnName] == 4) {
            column.visible = true;
            return false;
          }
        }
        let flag = column.btnLook == 0 || column.hidden;
        column.visible = !flag;
        // 过滤权限
        return flag;
        // return false
      };
    },
    formBtnColumnHidden () {
      return function (column) {
        // console.log('---------'+column.columnName+'---------'+this.showConditionData[column.columnName],this.showConditionData)
        // 优先隐藏条件
        if (this.showConditionData && this.showConditionData[column.columnName] != undefined) {
          // console.log('---------'+column.columnName+'---------'+this.showConditionData[column.columnName])
          if (this.showConditionData[column.columnName] == false) {
            column.visible = true;
            return true;
          } else {
            column.visible = false;
            return false;
          }
        }
        column.visible = column.hidden;
        // 过滤权限
        return column.hidden;
        // return false
      };
    },
    formColumnReadOnly () {
      return function (column) {
        // 优先判断流程配置权限
        if (this.authsMap && this.authsMap[this.config.id] && this.authsMap[this.config.id][column.columnName]) {
          // console.log(column.columnName+'-------------------',this.authsMap[this.config.id][column.columnName])
          if (this.authsMap[this.config.id][column.columnName] == 1) {
            return false;
          } else if (this.authsMap[this.config.id][column.columnName] == 2) {
            return true;
          } else if (this.authsMap[this.config.id][column.columnName] == 4) {
            return false;
          }
        }

        // 优先判断流程
        if (column.status) {
          if (column.btnEdit == 0) {
            return true;
          } else {
            return false;
          }
        }
        // 过滤权限
        if (this.readOnly || column.btnEdit == 0) {
          return true;
        }
        // if (this.readOnly) {
        //   return true
        // }
        return column.readOnly == undefined ? false : column.readOnly === 1;
      };
    },
    computeSelectFormValue () {
      return function (column, row) {
        return row[column.columnName + 'LABEL_'] ? row[column.columnName + 'LABEL_'] : row[column.columnName];
      };
    },
    computeOperateButtonOnly () {
      return function (button) {
        if (this.readOnly) {
          return true;
        }
        // console.log(button+'----computeOperateButtonOnly-----'+this.showConditionData[button],this.showConditionData)
        // 优先隐藏条件
        if (this.showConditionData && this.showConditionData[button] != undefined) {
          // console.log('---------'+column.columnName+'---------'+this.showConditionData[column.columnName])
          if (this.showConditionData[button] == false) {
            return false;
          } else {
            return true;
          }
        }
        if (button === 'topNew') {
          return this.showTopNewButton;
        } else if (button === 'topDelete') {
          return this.showTopDeleteButton;
        } else if (button === 'cellNew') {
          return this.showCellNewButton;
        } else if (button === 'cellDelete') {
          return this.showCellDeleteButton;
        }
        return false;
      };
    }
  },
  watch: {
    /*'config.tableData':{
      handler: function (val, oldval) {
        console.log('------config.tableData--------',val, oldval)
      },
      deep: true
    }*/
    // dicMap: {
    //   handler: function (val, oldval) {
    //     // console.log('------dicMap--------')
    //     // console.info(JSON.stringify(val))
    //   },
    //   deep: true// 对象内部的属性监听，也叫深度监听
    // }
    /* 'config.tableData' :{
        handler: function (val, oldval) {
          console.log('------tableData--------',val, oldval)
          // console.info(JSON.stringify(val))
        },
        deep: true// 对象内部的属性监听，也叫深度监听
    },
    showSummary:{
      handler: function (val, oldval) {
        console.log('------showSummary--------',val, oldval)
      },
      deep: true
    } */
  },
  created () {

  },
  mounted () {
    this.selectTableIndex = -1;
    this.selectTableRow = null;
    this.selectFormKey = '';
    this.selectFormVisible = false;
    this.selectFormConfig = {};
    this.showSummary = false;
    this.summaryColumns = {};
    this.expression = {};
    this.summaryData = {};
    this.config.dicMap = {};
    this.columnsMap = {};
    this.columnTitleMap = {};
    this.mainShowCondition = {};
    this.dataList = [];
    this.pageCount = 0;
    this.totalCount = 0;
    this.showPageBar = false;
    this.importErrorData = [];
    this.importErrorMsg = '';
    // this.rowKey = 'row.__id'
    // this.rowKey = undefined
    this.subFormConfig = undefined;
    this.init();
    // 判断是否是选择弹框，而且是单页面
  },
  methods: {
    ...mapMutations([
      'setFormConfig'
    ]),
    // 清空输入
    handleClear (row, column) {
      // console.log('----handleClear---11--',row, column);
      let _this = this;
      setTimeout(()=>{
        _this._handleClear(row,column);
      },10);
    },
    _handleClear(row,column){
      // console.log('----handleClear-----',row, column);
      this.$set(row, column.columnName, undefined);
      this.$set(row, column.columnName + 'LABEL_', undefined);
      // 判断是否是关联表单
      if(column.widgetType && (column.widgetType === 'select-form' || column.widgetType === 'open-form')){
        let selectFormKey = column.attr;
        getConfig(selectFormKey,this).then(config=>{
          // console.log('--getConfig---',config);
          // console.log('-----config.backFillMap------',config.backFillMap);
          if(config.backFillMap){
            for (let [key, value] of Object.entries(config.backFillMap)) {
              // console.log(key + ':' + value);
              this.$set(row, key, undefined);
            }
          }
          // console.log('----------',row);
        });
      }
      this.$forceUpdate();
    },
    init () {
      /* if (this.readOnly) {
        this.showTopNewButton = false
        this.showTopDeleteButton = false
        this.showCellNewButton = false
        this.showCellDeleteButton = false
      } */
      // console.log('---------init------'+this.showSummary)
      this.showTopNewButton = true;
      this.showTopDeleteButton = true;
      this.showCellNewButton = true;
      this.showCellDeleteButton = true;
      this.pageIndex = 1;
      let _this = this;
      let columns = [];
      let topBar = [];
      let summaryColumns = null;
      let expression = {};
      let onlyMainExpression = {};
      let mainExpression = {}; // 主表字段关联计算
      let ifNewBtn = false;
      let ifDeleteBtn = false;
      let wfFormAuth = this.config.wfFormAuth; // 流程权限
      let ifCopy = this.config.ifCopy;
      // 判断是否树表
      if (this.validUtil.isNotNull(this.config.rootId)) {
        this.isTree = true;
        this.config.isTree = true;
        this.pageSize = 1000000;
      } else {
        this.isTree = false;
        this.config.isTree = false;
      }
      // console.log(this.level+'----------',this.config)
      if (this.config.queryColumns) {
        let queryColumns = JSON.parse(JSON.stringify(this.config.queryColumns));
        queryColumns.forEach(column => {
          this.columnsMap[column.columnName] = column;
          this.columnTitleMap[column.title] = column.columnName;
          // 根据流程过程权限重新计算表单字段
          if (wfFormAuth && wfFormAuth[column.columnName]) {
            let status = wfFormAuth[column.columnName];
            // 1,可编辑;2,只读;3,隐藏;4,显示'
            if (status === 1 && !ifCopy) {
              column.status = status;
              column.btnEdit = 1;
              column.btnLook = 1;
              column.hidden = 0;
              column.readOnly = 0;
            } else if (status === 2 && !ifCopy) {
              column.status = status;
              column.btnEdit = 0;
              column.btnLook = 1;
              column.hidden = 0;
              column.readOnly = 1;
            } else if (status === 3) {
              column.status = status;
              column.btnEdit = 0;
              column.btnLook = 0;
              column.hidden = 1;
              column.readOnly = 1;
            }
          }

          // 处理隐藏条件信息
          if (this.validUtil.isNotNull(column.showCondition)) {
            this.initShowConditionConfig(column);
          }

          // console.log(column.columnName+'----------', column.btnEdit,column)
          if (column.javaType === 'TopButton') {
            if (column.columnName && column.columnName === 'new') {
              if (column.hidden && column.hidden === 1) {
                this.showTopNewButton = false;
              }
            } else if (column.columnName && column.columnName === 'delete') {
              if (column.hidden && column.hidden === 1) {
                this.showTopDeleteButton = false;
              }
            } else {
              topBar.push(column);
            }
          } else if (column.widgetType === 'sub-form') {
            // console.log('------sub-form------',column)
            this.subFormConfig = column.config;
            // // 传递表单对象
            // this.subFormConfig.parent = this.config.parent
            // this.subFormConfig.parentCmp = this
          } else if (column.javaType === 'CellButton') {
            if (column.columnName && column.columnName === 'new') {
              if (column.hidden && column.hidden === 1) {
                this.showCellNewButton = false;
              }
            } else if (column.columnName && column.columnName === 'delete') {
              if (column.hidden && column.hidden === 1) {
                this.showCellDeleteButton = false;
              }
            } else {
              columns.push(column);
            }
          } else {
            if (column.widgetType === 'select' || column.widgetType === 'switch') {
              let attr = column.attr;
              column['options'] = [];
              if (attr && attr.indexOf(',') > -1 && attr.indexOf(';') > -1) {
                _this.config.dicMap[column.columnName] = {};
                // 说明是直接写死类型
                let data = [];
                let options = attr.split(';');
                options.forEach(item => {
                  let option = item.split(',');
                  _this.config.dicMap[column.columnName][option[0]] = option[1];
                  // 存入键值对
                  data.push({name: option[1], value: column.javaType === 'Integer' ? parseInt(option[0]) : option[0]});
                });
                column.options = data;
              } else if (attr && attr.indexOf(',') > -1 && attr.indexOf(';') < 0) {
                _this.config.dicMap[column.columnName] = {};
                // 说明只有逗号
                let data = [];
                let options = attr.split(',');
                /*options.forEach(item => {

                });*/
                _this.config.dicMap[column.columnName][options[0]] = options[1];
                // 存入键值对
                data.push({name: options[1], value: column.javaType === 'Integer' ? parseInt(options[0]) : options[0]});
                column.options = data;
              } else if (attr && attr.indexOf(';') > -1 && attr.indexOf(',') < 0) {
                _this.config.dicMap[column.columnName] = {};
                // 说明只有逗号
                let data = [];
                let options = attr.split(';');
                options.forEach(item => {
                  _this.config.dicMap[column.columnName][item] = item;
                  // 存入键值对
                  data.push({name: item, value: column.javaType === 'Integer' ? parseInt(item) : item});
                });
                column.options = data;
              }
            } else if (column.widgetType === 'select-dic') {
              let attr = column.attr;
              column['options'] = [];
              _this.$set(_this.config.dicMap, column.columnName, {});
              // 加载数据字典
              if (_this.validUtil.isNotNull(attr)) {
                getDicData(attr).then(data => {
                  // _this.dicMap[column.columnName] = {};
                  data.forEach(item => {
                    _this.config.dicMap[column.columnName][item.value] = item['name'];
                  });
                  column.options = data;
                  // console.info(column.columnName + '-----加载完成----' + JSON.stringify(column.options))
                  // _this.$set(_this.dicMap, column.columnName, _this.dicMap[column.columnName]);
                  // console.info('-----加载完成----'+JSON.stringify(_this.dicMap))
                  // this.$forceUpdate()
                  // _this.$refs['jr-table'].doLayout();
                });
              }
            } else if (column.widgetType === 'select-sql') {
              let attr = column.attr;
              // 加载数据字典
              if (_this.validUtil.isNotNull(attr)) {
                // 添加全局项目属性
                let params = null;
                if (window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id)) {
                  params = JSON.parse(window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id));
                } else if (this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id]) {
                  params = this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id].data;
                  // console.log('------mainData-------', mainData, sessionProj)
                }
                if (params) {
                  params = {
                    'session-proj-code': params.PROJ_CODE_,
                    'session-proj-id': params.PROJ_ID_,
                    'session-proj-name': params.PROJ_NAME_,
                    'session-proj-uid': params.PROJ_UID_
                  };
                }
                getSqlDicData({formKey: this.config.formKey, columnId: column.id, params: params}).then(data => {
                  if (column.javaType === 'Integer') {
                    let newData = [];
                    data.forEach(item => {
                      newData.push({
                        value: parseInt(item.value),
                        name: item.name
                      });
                    });
                    data = newData;
                  }
                  column.options = data;
                  this.$forceUpdate();
                });
              }
            }
            if (column.summary) {
              if (summaryColumns === null) {
                summaryColumns = {};
              }
              // console.log(column.title+'---------'+column.columnName,column)
              summaryColumns[column.columnName] = column;
            }
            if (column.expression) {
              // 判断哪些字段会影响这个计算
              // _this.config.queryColumns.forEach(item => {
              //
              // })
              // 解析变量
              // for(var m = 0;m<column.expression;m++){
              //
              // }
              let keys = column.expression.match(/[A-Za-z][A-Za-z0-9_]*_/gi);
              // 去重
              let arr = [];
              if(keys){
                for (var i = 0; i < keys.length; i++) {    // 循环遍历当前数组
                  // 判断当前数组下标为i的元素是否已经保存到临时数组
                  // 如果已保存，则跳过，否则将此元素保存到临时数组中
                  if (arr.indexOf(keys[i]) == -1) {
                    arr.push(keys[i]);
                  }
                }
              }
              keys = arr;
              // 查找表达式中是否有主表字段
              let mainFields = column.expression.match(/\[(.*?)\]/gi); // 匹配所有类似[主表.项目名称]的变量
              let mainKeys = [];

              if (mainFields) {
                mainFields.forEach(key => {
                  let newKey = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));

                  let keyArray = newKey.split('.');
                  let formType = keyArray[0];
                  let columnTitle = keyArray[1];
                  if (formType === '主表') {
                    mainKeys.push({
                      columnTitle, key
                    });
                  }
                });
              }
              if (keys) {
                keys.forEach(key => {
                  if (expression[key] === undefined) {
                    expression[key] = {};
                  }
                  expression[key][column.columnName] = {
                    expression: column.expression,
                    keys: keys,
                    mainKeys
                  };
                });
              }
              if (mainKeys.length > 0) {
                mainKeys.forEach(item => {
                  let key = item.columnTitle;
                  if (mainExpression[key] === undefined) {
                    mainExpression[key] = {};
                  }
                  mainExpression[key][column.columnName] = {
                    expression: column.expression,
                    keys: keys,
                    mainKeys
                  };
                });
                if(!keys || keys.length == 0){
                  onlyMainExpression[column.columnName] = {
                    expression: column.expression,
                    keys: keys,
                    mainKeys
                  };
                }
              }
              // expression[column.columnName] = column.expression
            }
            // console.log(column.openUrl,column)
            columns.push(column);
          }
        });
        // console.info('----------------')
        if (this.config.formExcelList && this.config.formExcelList.length > 0) {
          topBar.push({
            icon: 'el-icon-download',
            title: '导入',
            widgetType: 'import',
            data: this.config.formExcelList
          });
        }
        if (summaryColumns !== null) {
          _this.summaryColumns = summaryColumns;
          this.showSummary = true;
          this.$forceUpdate();
        }
        // 过滤权限
        columns = columns.filter((item, index) => {
          return item.btnLook == 1;
        });
        /* this.columns = JSON.parse(JSON.stringify(columns))
        columns = this.handMoreColumns(JSON.parse(JSON.stringify(columns))) */

        this.columns = columns;
        columns = this.handMoreColumns(columns);
        this.expression = expression;
        this.mainExpression = mainExpression;
        this.onlyMainExpression = onlyMainExpression;

        // console.log('------mainExpression-----',this.mainExpression)
        // console.log('------expression-----', this.expression)
        this.moreColumns = columns;
        // console.log('------this.moreColumns-----', this.moreColumns)
        this.topBar = topBar;

        // 判断是否嵌套表格，也就是子表格
        if(this.level ===2 && this.config.tableData && this.config.tableData.length>0){
          this.computePageData(this.pageIndex);
        }
        this.$forceUpdate();
      }
    },
    initShowConditionConfig (column) { // 初始化字段隐藏条件
      let condition = column.showCondition;
      let _this = this;
      let columnName = column.columnName;
      if (columnName && columnName === 'new') {
        if (column.javaType) {
          if (column.javaType === 'TopButton') {
            columnName = 'topNew';
          } else if (column.javaType === 'CellButton') {
            columnName = 'cellNew';
          }
        }
      }
      // 先判断企业私有常量
      let keys = condition.match(/\{org-conf-(.*?)\}/gi); // 匹配所有类似{org-conf-ims.wf.sporadic.index}的变量
      if (keys) {
        keys.forEach(key => {
          let keyword = key.trim().substring(key.indexOf('{') + 1, key.indexOf('}'));
          // console.log('-------keyword------',keyword)
          let value = this.sessionUtil.getOrgConfByKey(keyword);
          if (this.validUtil.isNotNull(value)) {
            condition = condition.replace(key, value);
          }
        });
      }
      // console.log(column.title+'------condition------',condition)
      keys = condition.match(/\[(.*?)\]/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        let mainKeys = [];
        keys.forEach(key => {
          let newKey = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
          // console.info(columnName)
          let keyArray = newKey.split('.');
          let formType = keyArray[0];
          let columnTitle = keyArray[1];
          if (formType === '主表') {
            mainKeys.push({
              columnTitle, key
            });
          }
        });
        if (mainKeys.length > 0) {
          mainKeys.forEach(item => {
            let {columnTitle} = item;
            if (!this.mainShowCondition[columnTitle]) {
              this.mainShowCondition[columnTitle] = {};
            }
            this.mainShowCondition[columnTitle][columnName] = {
              rule: condition,
              mainKeys
            };
          });
        }
      } else {
        // 说明已经全部过滤完了
        try {
          // 默认显示
          let flag = false;
          let rule = 'flag = (' + condition + ')';
          eval(rule);
          // alert(("银行转帐" !== "银行转账"))
          // console.log('----------计算隐藏显示---------'+flag,rule)
          if (flag) {
            // 设置隐藏
            this.showConditionData[column.columnName] = true;
          } else {
            this.showConditionData[column.columnName] = false;
          }
          this.$forceUpdate();
        } catch (e) {
          console.log('----------计算隐藏显示----error-----', rule, e);
        }
      }
    },
    computeShowConditionConfig (mainColumnTitle) { // 计算显示隐藏规则
      // console.log(mainColumnTitle+'------computeShowConditionConfig------',this,this.mainShowCondition)
      let columns = [];
      let data = [];
      // 判断是主表字段变化调用handlerMainDataChange
      if (mainColumnTitle) {
        if (this.mainShowCondition[mainColumnTitle]) {
          data = [this.mainShowCondition[mainColumnTitle]];
        }
      } else {
        for (let key in this.mainShowCondition) {
          // console.log('---------key-------',key,this.mainShowCondition[key])
          data.push(this.mainShowCondition[key]);
        }
      }
      // console.log('------computeShowConditionConfig----data--',data)
      if (data.length > 0) {
        let mainData = this.getMainData();
        // console.log('---------computeShowConditionConfig--------',mainData)
        if (mainData) {
          data.forEach(config => {
            // console.log('------computeShowConditionConfig----config--',config)
            for (let desColumnName in config) {
              // console.log(desColumnName+'------1------',config[desColumnName])
              var {rule, mainKeys} = config[desColumnName];
              mainKeys.forEach(item => {
                let {key, columnTitle} = item;
                let val = this.config.parent.getValByColumnTitle(columnTitle);
                rule = rule.replace(key, val);
              });
              // console.log(desColumnName+'------------',rule)
              try {
                // 默认显示
                let flag = false;
                let condtion = 'flag = (' + rule + ')';
                // console.log(desColumnName+'------2------',condtion)
                eval(condtion);
                // alert(("银行转帐" !== "银行转账"))
                // console.log('----------计算隐藏显示---------'+flag,condtion)
                if (flag) {
                  // 设置隐藏
                  this.showConditionData[desColumnName] = true;
                } else {
                  this.showConditionData[desColumnName] = false;
                }
                this.$forceUpdate();
              } catch (e) {
                console.log('----------计算隐藏显示----error-----', rule, e);
              }
            }
          });
        }
      }

      columns.forEach(column => {
        // 计算隐藏显示
        if (column.showConditionData) {
          for (let desColumnName in column.showConditionData) {
            let ruleConfig = column.showConditionData[desColumnName];
            let rule = ruleConfig.rule + '';
            let keys = ruleConfig.keys;
            keys.forEach(key => {
              let srcColumnTitle = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
              let val = this.getValByColumnTitle(srcColumnTitle);
              rule = rule.replace(key, val);
            });
            try {
              // 默认显示
              let flag = false;
              rule = 'flag = (' + rule + ')';
              eval(rule);
              // alert(("银行转帐" !== "银行转账"))
              // console.log('----------计算隐藏显示---------'+flag,rule)
              if (flag) {
                // 设置隐藏
                this.showConditionData[desColumnName] = true;
              } else {
                this.showConditionData[desColumnName] = false;
              }
              this.$forceUpdate();
            } catch (e) {
              // console.log('----------计算隐藏显示----error-----',rule,e)
            }
          }
        }
      });
    },
    // 选人点击事件
    selectMember (column, row, index) {
      let selectList = [];
      if (column.widgetType === 'select-user') {
        // 如果不关联
        if (column.ifNotRelated == 1) {

        }else{
          if(this.validUtil.isNotNull(row[column.columnName])){
            selectList.push({
              id: row[column.columnName],
              userName: row[column.columnName+'LABEL_']
            });
          }
        }
      }
      //console.log((column.widgetType === 'select-user')+'---'+(column.ifNotRelated == 1)+'--selectMember-------',column, row, index,selectList);
      this.selectTableRow = row;
      this.selectTableIndex = index;
      this.selectMemberModels.selectList = selectList;
      this.selectMemberModels.isShow = true;
      this.selectMemberModels.form = column;
      this.selectMemberModels.radioSelectFlags = (column.widgetType === 'select-user');
    },
    // 选人回调函数
    memberCallBack () {
      this.selectMemberModels.isShow = false;
      var vm = this;
      let tableData = this.config.tableData;
      if (this.selectTableIndex > -1) {
        // 把第一行数据赋值给数组
        let row = tableData[this.selectTableIndex];
        this.columns.forEach(e => {
          if (e.columnName === this.selectMemberModels.form.columnName) {
            if (this.selectMemberModels.form.widgetType === 'select-user') {
              if (this.selectMemberModels.selectList.length > 0) {
                vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', this.selectMemberModels.selectList[0].userName);
                vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, this.selectMemberModels.selectList[0].id);
                // 如果不关联
                if (this.selectMemberModels.form.ifNotRelated == 1) {
                  vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, this.selectMemberModels.selectList[0].userName);
                  vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', this.selectMemberModels.selectList[0].userName);
                }
                // 如果是ID_或者UID_结束 给NAME_后缀插入中文
                if (e.columnName.lastIndexOf('UID_') > -1) {
                  let name = e.columnName.split('UID_');
                  vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', this.selectMemberModels.selectList[0].userName);
                }
                if (e.columnName.lastIndexOf('ID_') > -1) {
                  let name = e.columnName.split('ID_');
                  vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', this.selectMemberModels.selectList[0].userName);
                }
                // 如果是NAME_结束 给ID_后缀插入中文
                if (e.columnName.lastIndexOf('NAME_') > -1) {
                  let name = e.columnName.split('NAME_');
                  vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, this.selectMemberModels.selectList[0].userName);
                  vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'ID_', this.selectMemberModels.selectList[0].id);
                  vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'UID_', this.selectMemberModels.selectList[0].id);
                }
              } else {
                vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', '');
                vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, '');
              }
            } else if (this.selectMemberModels.form.widgetType === 'select-user-multi') {
              // eslint-disable-next-line no-unused-vars
              var labels = ''; var ids = '';
              this.selectMemberModels.selectList.forEach(element => {
                labels += element.userName + ',';
                ids += element.id + ',';
              });
              labels = labels.substring(0, labels.length - 1);
              ids = ids.substring(0, ids.length - 1);
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', labels);
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, ids);
              // 如果不关联
              if (this.selectMemberModels.form.ifNotRelated == 1) {
                vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, labels);
                vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', labels);
              }
              // 判断字段是否为ID_或UID_结尾 是则给NAME_也赋值
              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_');
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', labels);
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_');
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', labels);
              }
              // 如果是NAME_结束 给ID_后缀插入中文
              if (e.columnName.lastIndexOf('NAME_') > -1) {
                let name = e.columnName.split('NAME_');
                vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, labels);
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'ID_', ids);
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'UID_', ids);
              }
            } else if (this.selectMemberModels.form.widgetType === 'select-user-list') {
              var value = [];
              let attr = this.selectMemberModels.form.attr;
              let str = '';
              this.selectMemberModels.selectList.forEach(item => {
                if (attr && attr.indexOf(',') > -1) {
                  // 说明是直接写死类型
                  let options = attr.split(';');
                  options.forEach(item => {
                    let option = item.split(',');
                    // 存入键值对
                    if (item[option[1]]) {
                      item[option[0]] = item[option[1]];
                    }
                  });
                } else {
                  item.USER_NAME_ = item.userName;
                  item.USER_UID_ = item.id;
                  item.PICTURE_ = item.picture;
                }
                if (str) {
                  str += ',';
                }
                str += item.USER_NAME_;
                value.push(item);
              });
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', str);
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, value);
            }
          }
        });
      }
    },
    subMemberCallBack () { // 明细表选人事件
      // debugger
      this.subSelectMemberModels.isShow = false;
      var vm = this;
      // eslint-disable-next-line no-unused-vars
      let insertData = [];
      let idKey = vm.subSelectMemberModels.form.attr;
      this.subSelectMemberModels.selectList.forEach(element => {
        let nameKey = idKey.split('UID_')[0] + 'NAME_';
        let item = {};
        item[idKey] = element.id;
        item[idKey + 'LABEL_'] = element.userName;
        item[nameKey] = element.userName;
        item[nameKey + 'LABEL_'] = element.userName;
        insertData.push(item);
      });
      let tableData = this.config.tableData;
      // 过滤掉重复数据
      insertData = insertData.filter(item1 => {
        let item3 = tableData.find(item2 => {
          return item1[idKey] === item2[idKey];
        });
        return item3 === undefined;
      });
      if (insertData.length > 0) {
        tableData = tableData.concat(insertData);
      }
      this.config.tableData = tableData;
      this.computePageData(this.pageIndex);

      // 触发汇总合计
      this._handlerSummaryChange();
    },
    // 选部门点击事件
    selectQuerters (column, row, index) {
      let selectList = [];
      if (column.widgetType === 'select-depart') {
        // 如果不关联
        if (column.ifNotRelated == 1) {

        }else{
          if(this.validUtil.isNotNull(row[column.columnName])) {
            selectList.push({
              id: row[column.columnName],
              label: row[column.columnName + 'LABEL_'],
              departName: row[column.columnName + 'LABEL_']
            });
          }
        }
      }
      //console.log((column.widgetType === 'select-user')+'---'+(column.ifNotRelated == 1)+'--selectMember-------',column, row, index,selectList);
      this.selectTableRow = row;
      this.selectTableIndex = index;
      this.selectQuertersModels.selectList = selectList;
      this.selectQuertersModels.isShow = true;
      this.selectQuertersModels.form = column;
      this.selectQuertersModels.radioSelectFlags = (column.widgetType === 'select-depart');
    },
    // 选部门回调函数
    quertersCallBack () {

      this.selectQuerters.isShow = false;
      var vm = this;
      if (this.selectTableIndex > -1) {
        this.columns.forEach(e => {
          if (e.columnName === this.selectQuertersModels.form.columnName) {

            if (this.selectQuertersModels.selectList.length == 0) {
              // 清空
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', '');
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, '');
              return false;
            }

            if (this.selectQuertersModels.form.widgetType === 'select-depart') {
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', this.selectQuertersModels.selectList[0].label);
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, this.selectQuertersModels.selectList[0].id);
              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_');
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', this.selectQuertersModels.selectList[0].label);
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_');
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', this.selectQuertersModels.selectList[0].label);
              }
            } else if (this.selectQuertersModels.form.widgetType === 'select-depart-multi') {
              // eslint-disable-next-line no-unused-vars
              var labels = ''; var ids = '';
              this.selectQuertersModels.selectList.forEach(element => {
                labels += element.label + ',';
                ids += element.id + ',';
              });
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName + 'LABEL_', labels.substring(0, labels.length - 1));
              vm.$set(this.config.tableData[this.selectTableIndex], e.columnName, ids.substring(0, ids.length - 1));

              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_');
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', labels.substring(0, labels.length - 1));
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_');
                vm.$set(this.config.tableData[this.selectTableIndex], name[0] + 'NAME_', labels.substring(0, labels.length - 1));
              }
            }
          }
        });
      }
    },
    // 处理生成多表头格式
    handMoreColumns (fields) {
      // 处理多表头
      let fieldsmap = [];
      // 遍历所有字段组织多表头的数据位
      for (let i = 0; i < fields.length; i++) {
        let title = fields[i].title;
        // System.out.println("1===" + title + "==");
        if (title.indexOf('-') > -1) {
          let titles = title.split('-');
          let length = titles.length;
          let j = length;
          if (fieldsmap.find(event => { return event.title === titles[0]; })) {
            let temp = fieldsmap.find(event => { return event.title === titles[0]; });
            let k = 1;
            for (k = 1; k < length - 1; k++) {
              if (temp.children.find(event => { return event.title === titles[k]; })) {
                temp = temp.children.find(event => { return event.title === titles[k]; });
              } else {
                for (let m = k; m < length - 1; m++) {
                  if (!temp.children) {
                    temp.children = [];
                  }
                  temp.children.push({title: titles[m], children: [] });
                  temp = temp.find(event => { return event.title === titles[m]; });
                }
                break;
              }
            }
            if (!temp.children) {
              temp.children = [];
            }
            fields[i].title = titles[length - 1];
            fields[i].fullTitle = title;
            temp.children.push(fields[i]);
          } else {
            fieldsmap.push({title: titles[0], children: [] });
            let temp = fieldsmap.find(event => { return event.title === titles[0]; });
            for (let k = 1; k < length - 1; k++) {
              if (!temp.children) {
                temp.children = [];
              }
              temp.children.push({title: titles[k], children: [] });
              temp = temp.children.find(event => { return event.title === titles[k]; });
            }
            if (!temp.children) {
              temp.children = [];
            }
            fields[i].title = titles[length - 1];
            fields[i].fullTitle = title;
            temp.children.push(fields[i]);
          }
        } else {
          fieldsmap.push(fields[i]);
        }
      }
      return fieldsmap;
    },
    getMainData () { // 获取主表数据
      let mainData = this.config.parent.getData().mainFormDataMap;
      return mainData;
    },
    getTableData (params) { // 加载明细表数据
      if (this.config.isTree) {
        return getTreeData(params, this);
      } else {
        return getGridData(params, this);
      }
    },
    computePageData(pageIndex){ // 组装分页数据
      let tableData = this.config.tableData;
      if(this.config.isTree){
        this.dataList = tableData;
        return;
      }
      if(tableData.length>this.pageSize){
        this.showPageBar = true;
      }else{
        this.showPageBar = false;
      }
      if(tableData.length>0){
        this.totalCount = tableData.length;
        this.pageCount = parseInt((this.totalCount + this.pageSize - 1) / this.pageSize);
      }else{
        this.totalCount = 0;
        this.pageCount = 0;
      }
      // console.log(pageIndex+'-------computePageData--------',this.totalCount,this.pageCount,tableData)
      if(pageIndex){
        this.handlePageIndexChange (pageIndex);
      }
    },
    handleSizeChange (pageSize) { // pageSize切换
      // console.log('------handleSizeChange------');
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.computePageData(this.pageIndex);
      //this.loadData()
    },
    handlePageIndexChange (pageIndex) { // pageSize切换
      // console.log('------handlePageIndexChange------',pageIndex);
      // console.info(this)
      let pageCount = this.pageCount;
      if (pageIndex <= pageCount) {
        this.pageIndex = pageIndex;
      }else{
        this.pageIndex = 1;
      }
      this.loadTableData();
    },
    loadTableData(){
      let data = this.config.tableData;
      let start = (this.pageIndex-1)*this.pageSize;
      if(data.length>start){
        data = data.slice(start,start+this.pageSize);
      }
      this.dataList = data;
      // console.log(this.dataList.length+'-------loadTableData-----',this.dataList);
    },
    loadData (businessKey) { // 初始化数据
      // 初始化根据主表字段设置显示隐藏
      this.computeShowConditionConfig();
      this.pageIndex = 1;
      // console.info(this.config)
      // console.info(this.config.title+'----loadData---businessKey------'+businessKey)
      // console.log(businessKey)
      if (this.validUtil.isNotNull(businessKey)) {
        let _this = this;
        let config = this.config;
        // console.info(config)
        // 判断是否搜索,然后拼接搜索
        let params = {
          'formKey': config.formKey,
          'formId': config.formId,
          'subForm': true,
          'id': config.id,
          'businessKey': businessKey,
          'tableName': config.tableName
        };
        let vm = this;
        // 先判断是否有修改初始化
        let event = this.getEditRenderApi();
        if (event && event != null) {
          this.loadDataByEvent(event, businessKey);
        } else {
          this.ifFormEditRender = true;
          this.loading = true;
          // console.log('--------isTree-------'+this.config.isTree)
          this.getTableData(params).then(res => {
            if (this.config.isTree) {
              res = {
                data: res
              };
            }
            // console.info('--------getTableData-------',res,res.data)
            if (res.data && res.data.length > 0) {
              // console.log('--------start-------'+new Date())
              // console.info('--------getTableData----2---',res,res.data)
              let data = res.data;//.slice(0,20);
              // 递归组装初始化数据
              _this.deepRenderData(data);
              // console.log('--------end-------',res.data)

              _this.config.tableData = data;
              // 分页显示
              this.computePageData(this.pageIndex);

              // 触发汇总合计
              this._handlerSummaryChange();

              _this.$forceUpdate();
            } else {
              // 如果原本没有数据，则判断是否有初始化事件
              let event = _this.getRenderApi();
              // console.log(event)
              if (event && event != null) {
                _this.loadDataByEvent(event, businessKey);
              } else {
                if (!this.config.tableData || this.config.tableData.length === 0) {
                  // this.addRow();
                }
              }
            }
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      } else {
        // 判断是否绑定事件有初始化
        let event = this.getRenderApi();
        if (event && event != null) {
          this.loadDataByEvent(event, businessKey);
        } else {
          if (!this.config.tableData || this.config.tableData.length === 0) {

          }
        }
      }
    },
    loadSonData (item) { // 用于行内展开加载明细表数据
      let businessKey = item['ID_'];
      if (this.validUtil.isNotNull(businessKey)) {
        let _this = this;
        let config = item.subFormConfig;
        // console.info(config)
        // 判断是否搜索,然后拼接搜索
        let params = {
          'formKey': config.formKey,
          'formId': config.formId,
          'subForm': true,
          'id': config.id,
          'businessKey': businessKey,
          'tableName': config.tableName
        };
        this.ifFormEditRender = true;
        this.loading = true;
        // console.log('--------isTree-------'+this.config.isTree)
        this.getTableData(params).then(res => {
          if (config.isTree) {
            res = {
              data: res
            };
          }
          // console.info('--------getTableData-------',res,res.data)
          if (res.data && res.data.length > 0) {
            // console.log('--------start-------'+new Date())
            // 递归组装初始化数据
            _this.deepRenderData(res.data, false);
            // console.log('--------end-------',res.data)

            config.tableData = res.data;
            _this.$forceUpdate();
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    loadDataByEvent (event, businessKey) { // 通过注册事件执行加载数据
      this.loading = true;
      let _this = this;
      let mainData = this.config.parent.getData().mainFormDataMap;
      // console.info(mainData)

      let queryParams = [];
      // 组装参数
      for (let key in mainData) {
        queryParams.push({key: key, value: mainData[key]});
      }

      let config = this.config;
      // console.info(config)
      // 判断是否搜索,然后拼接搜索
      let params = {
        apiId: event.apiId,
        'formKey': config.formKey,
        'formId': config.formId,
        'subForm': true,
        'id': config.id,
        'businessKey': businessKey,
        'tableName': config.tableName,
        queryParams: queryParams
      };
      // console.info(event)
      // console.info('0000'+event['runtype'])
      if (API_RUN_TYPE.isInterface(event.apiConfig['runtype'])) {
        params._url = event['runsql'];
      }
      this.getTableData(params).then(res => {
        if (!res) {
          _this.config.tableData = [];
          this.loading = false;
          // 分页显示
          _this.computePageData(this.pageIndex);

          // 触发汇总合计
          this._handlerSummaryChange();
          _this.$forceUpdate();
          return;
        }
        // console.log('---------getTableData-----------',res)
        if (!res.status) {
          res = {
            data: res
          };
        }

        if (res.data && res.data.length > 0) {
          // 判断是否需要重置id
          if (event.resetId) {
            _this.deepPackTreeData(res.data, _this.config.rootId);
          } else {
            // 递归组装初始化数据
            _this.deepRenderData(res.data);
          }
          // console.log('---------loadDataByEvent-----------',res.data)
          _this.config.tableData = res.data;
          // 分页显示
          _this.computePageData(this.pageIndex);

          // 触发汇总合计
          this._handlerSummaryChange();
          _this.$forceUpdate();
        }else{
          // 说明是没有数据
          _this.config.tableData = [];
          // 分页显示
          _this.computePageData(this.pageIndex);

          // 触发汇总合计
          this._handlerSummaryChange();
          _this.$forceUpdate();
        }
        this.loading = false;
      });
    },
    deepRenderData (data, deepLoad) { // loadData之后递归初始化树表数据, resetId表示是否重新替换id,和parentId
      /**
       * deepLoad只会在loadSonData中传递，避免明细表死循环加载调用
       */
        //console.log('-------deepRenderData--------',data)
      let vm = this;
      data.forEach(item => {
        if (!item['id']) {
          item['id'] = getUUID();
        }
        // 判断是否有多层明细表
        if (this.subFormConfig && (deepLoad == undefined || deepLoad)) {
          item.subFormConfig = {...this.subFormConfig};

          item.subFormConfig.parent = this.config.parent;
          item.subFormConfig.parentCmp = this;
          item.subFormConfig.parentRow = item;

          // 模拟加载明细表数据
          // item.subFormConfig.tableData = [{},{}]
          // 加载数据
          this.loadSonData(item);
        }
        // console.log('---deepRenderData--forEach----1---',JSON.stringify(item))
        vm.columns.forEach(column => {
          // console.log('---deepRenderData--forEach---2----',column.columnName)
          if (item[column.columnName]) {
            if ((column.javaType === 'Double' || column.javaType === 'Integer') && (column.widgetType == 'select' || column.widgetType == 'select-dic' || column.widgetType == 'select-sql')) {
              item[column.columnName] = parseInt(item[column.columnName]);
            } else {
              item[column.columnName] = item[column.columnName] + '';
            }
          }

          item[column.columnName + 'isShow'] = false;
          if (item[column.columnName] === undefined) {
            item[column.columnName] = undefined;
          }
          if (column.widgetType && column.widgetType === 'select-form') {
            if (item[column.columnName + 'LABEL_'] === undefined) {
              item[column.columnName + 'LABEL_'] = item[column.columnName];
            }
          }
          if (column.multiple == 1 && (column.widgetType == 'select' || column.widgetType == 'select-dic' || column.widgetType == 'select-sql')) {
            if (item[column.columnName]) {
              item[column.columnName] = item[column.columnName].split(',');
            } else {
              item[column.columnName] = null;
            }
          }
          if (this.config.isTree) {
            if (!item['children']) {
              item['children'] = [];
            }
            // 递归初始化下级
            this.deepRenderData(item['children']);
          }

          // console.log(column.columnName+'---deepRenderData--forEach----2---',JSON.stringify(item))
          this._handlerChangeValue(item[column.columnName], column, item, -1, false,true);
        });

        // console.log('---deepRenderData--forEach----3---',JSON.stringify(item))
      });
    },
    getRenderApi () {
      // console.info(this.config)
      if (this.config.events) {
        let events = this.config.events.find(event => {
          // console.info(event)
          return parseInt(event.type) === EVENT_TYPE.NEW_REDNER;
        });
        return events;
      }
      return null;
    },
    getEditRenderApi () { // 编辑初始化
      // console.info(this.config)
      // console.log('------getEditRenderApi-------', this.config.events)
      if (this.config.events) {
        let events = this.config.events.find(event => {
          // console.info(event)
          return parseInt(event.type) === EVENT_TYPE.EDIT_REDNER;
        });
        return events;
      }
      return null;
    },
    handlerSelectionChange (selection) { // 获取复选框选中事件
      this.selection = selection;
    },
    handlerCurrentChange (currentRow, oldCurrentRow) { // 当表格的当前行切换时触发
      this.currentRow = currentRow;
      // console.log('------handlerCurrentChange-------', this.currentRow)
    },
    removeRow () { // 根据复选框删除
      if (this.selection.length === 0) {
        this.util.warn('请选择一行数据');
        return;
      }
      if (this.config.isTree) {
        // 树表删除做法
        this.selection.forEach(node => {
          let parentNode = node ? this.getParentNode(this.config.tableData, node['parentId']) : undefined;
          // console.log('-----removeRow---',parentNode,node,this.config.tableData)
          if (parentNode) {
            parentNode.children = parentNode.children.filter(item => {
              let flag = true;
              if (item.id === node.id) {
                for (let summaryColumnName in this.summaryColumns) {
                  let column = this.summaryColumns[summaryColumnName];
                  if (column) {
                    // 递归向上计算,而且因为是删除，所以值为0
                    node[column.columnName] = 0;
                    this.deepUpSummary(column, node);
                  }
                }
                flag = false;
              }
              return flag;
            });
          } else {
            // 说明父亲是根节点
            this.config.tableData = this.config.tableData.filter(item => {
              let flag = true;
              if (item.id === node.id) {
                flag = false;
              }
              return flag;
            });
            this.dataList = this.config.tableData;
          }
          // console.log('-------removeRow-------', node, parentNode,this.config.tableData)
        });
      } else {
        this.config.tableData = this.config.tableData.filter(item => {
          let flag = true;
          if (this.selection.indexOf(item) > -1) {
            flag = false;
          }
          return flag;
        });
        // 重新分页
        this.computePageData(this.pageIndex);

      }

      // 触发汇总合计
      this._handlerSummaryChange();
      // console.info(this.config.tableData)
      this.$forceUpdate();
    },
    deleteRow (index, row, rows) {
      if (row && this.validUtil.isNotNull(row['PROC_STATUS_'])) {
        this.util.warn('该数据已提交，无法删除!');
        return;
      }
      // 移除一行
      if (this.config.tableData.length > 0) {
        //   console.log("before", JSON.stringify(this.tableData));
        this.config.tableData.splice(((this.pageIndex-1)*this.pageSize+index), 1); // 删掉该行
        //   console.log("afters", JSON.stringify(this.tableData));
      }

      // 重新计算分页
      this.computePageData(this.pageIndex);
      // 解决删除主表不触发改变bug
      this.handlerChangeValue('', null, row, index, true);
      // this.handleChange()
    },
    getConstValue (key) { // 根据key获取常量值
      // console.info(column)
      if (key === 'current-user-uid' || key === '当前用户主键') {
        return this.sessionUtil.getUserUid();
      } else if (key === 'current-user-id' || key === '当前用户编码') {
        return this.sessionUtil.getUserId();
      } else if (key === 'current-user-name' || key === '当前用户名称') {
        return this.sessionUtil.getUserName();
      } else if (key === 'current-depart-uid' || key === '当前部门主键') {
        return this.sessionUtil.getDepartUid();
      } else if (key === 'current-depart-id' || key === '当前部门编码') {
        return this.sessionUtil.getDepartId();
      } else if (key === 'current-depart-name' || key === '当前部门名称') {
        return this.sessionUtil.getDepartName();
      } else if (key === 'current-company-uid' || key === '当前组织主键') {
        return this.sessionUtil.getDepartUid();
      } else if (key === 'current-company-id' || key === '当前组织编码') {
        return this.sessionUtil.getDepartId();
      } else if (key === 'current-company-name' || key === '当前组织名称') {
        return this.sessionUtil.getDepartName();
      } else if (key === 'current-date' || key === '当前日期') {
        return (new Date()).format('yyyy-MM-dd');
        // mainData[column.columnName] = new Date()
      } else if (key === 'current-datetime' || key === '当前日期时间') {
        return new Date();
        // mainData[column.columnName] = (new Date()).format("yyyy-MM-dd hh:mm:ss")
      } else if (key === 'current-year' || key === '当前年' || key === '本月') {
        return new Date().getFullYear();
      } else if (key === 'current-month' || key === '当前月' || key === '本月') {
        return new Date().getMonth() + 1;
      } else if (key === 'current-week' || key === '当前周' || key === '本周') {
        return this.util.getYearWeek();
      } else if (key === 'current-next-monday' || key === '下周一') { // 下周一
        return this.util.getNextMonday();
      } else if (key === 'current-month-first' || key === '本月第一天') { // 本月第一天
        return this.util.getCurrentMonthFirst();
      } else if (key === 'current-month-last' || key === '本月最后一天') { // 本月最后一天
        return this.util.getCurrentMonthLast();
      } else if (key === 'next-month-first' || key === '下月第一天') { // 下月第一天
        return this.util.getNextMonthFirst();
      } else if (key === 'next-month-last' || key === '下月最后一天') { // 下月最后一天
        return this.util.getNextMonthLast();
      } else {
        let sessionProj = null;
        if (window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id)) {
          sessionProj = JSON.parse(window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id));
        } else if (this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id]) {
          sessionProj = this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id].data;
          // console.log('------mainData-------', mainData, sessionProj)
        }
        if (sessionProj) {
          sessionProj = {
            'session-proj-code': sessionProj.PROJ_CODE_,
            'session-proj-id': sessionProj.PROJ_ID_,
            'session-proj-name': sessionProj.PROJ_NAME_,
            'session-proj-uid': sessionProj.PROJ_UID_
          };
          for (const edit in sessionProj) {
            if (key.indexOf(edit) > -1) {
              key = key.replace(new RegExp('{' + edit + '}', 'gm'), sessionProj[edit]);
            }
          }
        }
        return key;
      }
    },
    addRow (index, data, event) {
      if (this.isTree) {
        this.addNode();
        return;
      }
      // console.info('--------')
      // 新增一行
      var vm = this;
      var cellObj = null;
      if (data) {
        cellObj = {...data};
      } else {
        cellObj = {CODE_: '', id: getUUID()};
      }
      // 判断是否有多层明细表
      if (this.subFormConfig) {
        if (!cellObj.subFormConfig) {
          cellObj.subFormConfig = {...this.subFormConfig};

          cellObj.subFormConfig.parentRow = cellObj;
          cellObj.subFormConfig.parent = this.config.parent;
          cellObj.subFormConfig.parentCmp = this;
        }
      }
      vm.columns.forEach(column => {
        cellObj[column.columnName + 'isShow'] = false;
        if (vm.validUtil.isNull(cellObj[column.columnName])) {
          cellObj[column.columnName] = undefined;
          // 判断是否是固定常量
          if (column.sourceType === 'const') {
            cellObj[column.columnName] = column.sourceAttr;
          } else if (column.sourceType === 'sys-conf') { // 判断如果是系统常量
            cellObj[column.columnName] = this.getConstValue(column.sourceAttr);
          }
          if (column.widgetType && column.widgetType === 'select-form') {
            if (cellObj[column.columnName + 'LABEL_'] === undefined) {
              cellObj[column.columnName + 'LABEL_'] = cellObj[column.columnName];
            }
          }
        } else {
          let widgetType = column.widgetType;
          if (widgetType) {
            if (widgetType === 'select-date') {
              if (vm.validUtil.isNull(cellObj[column.columnName + 'LABEL_'])) {
                cellObj[column.columnName + 'LABEL_'] = cellObj[column.columnName];
              }
            }
          }
        }
        // console.log('-----------',this.onlyMainExpression,this.mainExpression);
        if(this.onlyMainExpression[column.columnName]){
          let expressionConfig = {};
          expressionConfig[column.columnName ] = this.onlyMainExpression[column.columnName];
          this._executeExpression (expressionConfig, cellObj, index+1, true);
        }else{
          cellObj = this._handlerChangeValue(cellObj[column.columnName], column, cellObj, 0, true,true);
        }


      });
      // this.tableKey.forEach(function(obj) {
      //   vm.$set(cellObj, obj.value, "");
      // });
      if (vm.config.tableData === undefined) {
        vm.config.tableData = [];
      }
      if (index != undefined) {
        //console.log('-----addRow------',index)
        vm.config.tableData.splice(((this.pageIndex-1)*this.pageSize+index), 0, cellObj);
      } else {
        vm.config.tableData.push(cellObj);
        // 判断新增的行是否需要下一页显示
        this.pageIndex = parseInt((vm.config.tableData.length + this.pageSize - 1) / this.pageSize);
      }
      this.computePageData(this.pageIndex);
      this.$forceUpdate();
    },
    getParentNode (data, parentId) { // 递归父节点
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          if (item['id'] === parentId) {
            return item;
          }
          if (item['children']) {
            let node = this.getParentNode(item['children'], parentId);
            if (node) {
              return node;
            }
          }
        }
      }
      return undefined;
    },
    addNode (index) { // 如果是树，同级新增
      // 查找上级
      let currentRow = this.getCurrentRow();
      let parentNode = currentRow ? this.getParentNode(this.config.tableData, currentRow['parentId']) : undefined;
      // console.log('---------addNode-------',this.config.tableData, currentRow, parentNode)
      if (!parentNode) {
        parentNode = {
          id: this.config.rootId,
          ID_: this.config.rootId,
          children: this.config.tableData
        };
      }
      var vm = this;
      var cellObj = {id: getUUID(), CODE_: '', parentId: parentNode['id'], children: []};
      vm.columns.forEach(column => {
        cellObj[column.columnName + 'isShow'] = false;
        cellObj[column.columnName] = undefined;
        if (column.widgetType && column.widgetType === 'select-form') {
          if (cellObj[column.columnName + 'LABEL_'] === undefined) {
            cellObj[column.columnName + 'LABEL_'] = cellObj[column.columnName];
          }
        }
      });
      if (!parentNode.children) {
        parentNode.children = [];
      }
      // parentNode['hasChildren'] = true
      parentNode.children.push(cellObj);
      this.dataList = this.config.tableData;
      this.$forceUpdate();
      // console.log('---addNode----', parentNode, this.config.tableData, JSON.stringify(this.config.tableData))
    },
    addChildNode () { // 如果是树，下级新增
      let parentNode = this.getCurrentRow();
      if (!parentNode) {
        parentNode = {
          id: this.config.rootId,
          ID_: this.config.rootId,
          children: this.config.tableData
        };
      }

      var vm = this;
      var cellObj = {id: getUUID(), CODE_: '', parentId: parentNode['id'], children: []};
      vm.columns.forEach(column => {
        cellObj[column.columnName + 'isShow'] = false;
        cellObj[column.columnName] = undefined;
        if (column.widgetType && column.widgetType === 'select-form') {
          if (cellObj[column.columnName + 'LABEL_'] === undefined) {
            cellObj[column.columnName + 'LABEL_'] = cellObj[column.columnName];
          }
        }
      });

      if (!parentNode.children) {
        parentNode.children = [];
      }
      // parentNode['hasChildren'] = true
      parentNode.children.push(cellObj);
      // console.log('---addChildNode----', parentNode, this.config.tableData, JSON.stringify(this.config.tableData));
      this.$forceUpdate();
    },
    getCurrentRow () { // 获取当前选中行
      return this.currentRow;
    },
    getValByColumnTitle (srcColumnTitle, srcColumn, row) { // 根据字段名称获取val
      let _this = this;
      let srcColumnName = _this.columnTitleMap[srcColumnTitle];
      if (srcColumn == undefined || srcColumn == null) {
        srcColumn = _this.columnsMap[srcColumnName];
      }
      // console.info(srcColumnTitle+'-----getValByColumnTitle----'+srcColumnName)
      let val = null;
      if (srcColumn && srcColumnName) {
        // 说明是数据库字段
        if (srcColumn.widgetType === 'select-form' || srcColumn.widgetType === 'select-user' || srcColumn.widgetType === 'select-depart') {
          val = '"' + row[srcColumnName + 'LABEL_'] + '"';
          // console.info('---val----'+val)
        } else if (srcColumn.widgetType === 'select' || srcColumn.widgetType === 'select-dic' || srcColumn.widgetType === 'select-sql') {
          let options = srcColumn.options;
          // console.info(srcColumnTitle+'-----getValByColumnTitle--1--'+options)
          if (options) {
            let option = options.find(option => {
              return option.value === row[srcColumnName];
            });
            if (option) {
              val = '"' + option.value + '"';
            }
          }
        } else if (srcColumn.widgetType === 'select-date' || srcColumn.widgetType === 'select-time' || srcColumn.widgetType === 'select-date-time') {
          val = '"' + row[srcColumnName] + '"';
        } else {
          // console.log('----------22-----------',srcColumnName,srcColumn)
          if (srcColumn.javaType === 'String') {
            val = '"' + row[srcColumnName] + '"';
          } else {
            val = row[srcColumnName];
          }
        }
        // console.info(srcColumnTitle+'----'+srcColumn.javaType+'-----'+val)
        if (val == 'undefined' || val == '"undefined"' || val === undefined || val === null || val === '') {
          if (srcColumn.javaType === 'Integer' || srcColumn.javaType === 'Double' || srcColumn.javaType === 'Float') {
            val = 0;
          } else {
            val = '""';
          }
        }
      } else {
        // 判断是否系统常量
        val = '"' + this.sessionUtil.getConstValue(this, srcColumnTitle) + '"';

      }
      // console.info(srcColumnTitle+'---22222-----'+val)
      // console.info(key+'--'+(val == '"undefined"')+'--'+typeof val+'--'+val)
      // console.info(val.length+'--'+'undefined'.length)
      if (val == 'undefined' || val == '"undefined"' || val === undefined || val === null) {
        val = '""';
      }
      return val;
    },
    computeDisabledConditionConfig (column, row) { // 计算禁用规则
      let rule = column.disabledCondition;
      let _this = this;
      // console.log('---computeDisabledConditionConfig----',_this)
      let keys = rule.match(/\[(.*?)\]/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let columnName = key.trim().substring(key.indexOf('[') + 1, key.indexOf(']'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let colName = _this.columnTitleMap[columnName];
          let col = _this.columnsMap[colName];
          if (col !== undefined && col !== null) {
            let val = this.getValByColumnTitle(columnName, col, row);
            rule = rule.replace(key, val);
          } else {
            // 也许是系统常量
            if(columnName === '叶子'){
              let val = true;
              if(row.children != undefined && row.children.length>0){
                val = false;
              }
              rule = rule.replace(key, val);
            }
          }
        });
      } else {
        // 说明已经全部过滤完了
      }

      keys = rule.match(/\{(.*?)\}/gi); // 匹配所有类似[项目名称]的变量
      if (keys) {
        keys.forEach(key => {
          let colName = key.trim().substring(key.indexOf('{') + 1, key.indexOf('}'));
          // console.info(columnName)
          // 先判断是否是表单字段
          let col = _this.columnsMap[colName];
          if (col !== undefined && col !== null) {
            let columnName = col.title;
            let val = this.getValByColumnTitle(columnName, col, row);
            rule = rule.replace(key, val);
          } else {
            // 也许是系统常量
            let val = this.sessionUtil.getConstValue(this,colName);
            rule = rule.replace(key, val);
          }
        });
      }
      try {
        // 默认显示
        let flag = false;
        rule = 'flag = (' + rule + ')';
        eval(rule);
        // alert(("银行转帐" !== "银行转账"))
        // console.log('----------计算禁用显示---------'+flag,rule)
        if (flag) {
          // 设置警用
          return true;
        } else {
          return false;
        }
        this.$forceUpdate();
      } catch (e) {
        console.log('----------计算禁用显示----error-----', rule, e);
        return false;
      }
    },
    dblClick (row, column, index) {
      // console.log('-----dblClick-------',row, column, index);
      if(this.validUtil.isNotNull(column.disabledCondition)){
        let disabled = this.computeDisabledConditionConfig(column,row);
        // console.log('----disabled----',disabled);
        if(disabled){
          return;
        }
      }
      // 如果是附件选择框则不做任何操作
      if (column.widgetType && column.widgetType === 'file') {
        return;
      }
      if (column.openUrl && column.openParams) {
        this.handleRowButtonClick(column, index, row);
      }
      // 优先判断流程配置权限
      if (this.authsMap && this.authsMap[this.config.id] && (this.authsMap[this.config.id][column.columnName] == 1 || this.authsMap[this.config.id][column.columnName] == 4)) {

      } else {
        // 优先判断流程权限
        if (column.status && column.btnEdit) {

        } else {
          if (this.readOnly || column.readOnly || this.validUtil.isNotNull(row['PROC_STATUS_'])) {
            return;
          }
        }
      }

      //console.info('-----dblClick------');
      this.$set(row, column.columnName + 'isShow', true);
      // row[column.columnName + 'isShow'] = true
      if (!column.widgetType || (column.widgetType && column.widgetType != 'date')) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs[column.columnName + index][0].focus();
          });
        }, 100);
      }
      // this.addRow();
      // this.deleteRow(this.tableData.length - 1, this.tableData);
    },
    handlerTopBarClick (button) { // topBar单击触发
      if (button.widgetType === 'select-form') {
        // 是否客户自定义传参
        let isCustomQueryParams = false;
        this.queryParams = this.config.parent.getData().mainFormDataMap;
        try {
          if (button.attr.indexOf('{') > -1) {
            let d = JSON.parse(button.attr);
            button.selectFormKey = d.formKey;
            if (d.queryParams) {
              this.queryParams = d.queryParams;
              isCustomQueryParams = true;
            }
          } else {
            button.selectFormKey = button.attr;
          }
        } catch (e) {
          console.log('---edit-table--handlerTopBarClick--parse attr----e---', button.selectFormKey, e);
          button.selectFormKey = button.attr;
        }
        this.selectFormKey = button.selectFormKey;
        this.selectTableRow = null;
        this.selectTableIndex = -1;
        this.selectFormColumn = null;
        // let formConfig = {}
        // getConfig(this.selectFormKey, this).then(data => {
        //   for (var key in data) {
        //     formConfig[key] = data[key]
        //   }
        //   if (formConfig) {
        //     this.selectFormTitle = formConfig.title
        //     // console.info('------this.selectFormTitle-------'+this.selectFormTitle)
        //   }
        // })
        // console.log('-----this.queryParams-----',this.queryParams,this.config.parentRow)
        // 判断是否第三层明细表,如果自定义查询参数则不需要自动拼接上一层字段
        if (this.level === 2 && !isCustomQueryParams) {
          let parentRow = this.config.parentRow;
          if (parentRow) {
            for (let key in parentRow) {
              if (key.indexOf('_isShow') < 0 && key !== 'subFormConfig') {
                this.queryParams[key] = parentRow[key];
              }
            }
          }
          // console.log(button.title+'--------------------',parentRow,this.queryParams)
        }
        this.openDialogWidth = button.openWidth ? button.openWidth : 900;
        this.openDialogHeight = button.openHeight ? button.openHeight : 600;
        this.selectFormConfig = {};
        this.selectFormSingleSelect = false;
        this.selectFormVisible = true;
      } else if (button.widgetType === 'import') {
        this.selectExcelVisible = true;
        this.excelList = button.data;
      } else if (button.widgetType === 'top-button') {
        this.handleRowButtonClick(button);
      } else if (button.widgetType === 'select-user-multi') {
        this.subSelectMemberModels.isShow = true;
        this.subSelectMemberModels.form = button;
        this.subSelectMemberModels.radioSelectFlags = (button.widgetType === 'select-user');
      } else if (button.widgetType === 'ocr-invoice') {
        if (button.attr) {
          let config = JSON.parse(button.attr);
          this.ocrConfig = config;
        } else {
          // 默认
          this.ocrConfig = {
            fileColumnName: 'INVOICE_FILE_',
            mappings: {
              INVOICE_TYPE_: 'invoiceType',
              INVOICE_CODE_: 'invoiceCode',
              INVOICE_NUM_: 'invoiceNum',
              PURCHASER_NAME_: 'purchaserName',
              TAX_MONEY_: 'amountInFiguers',
              TAX_RATE_: 'taxRate',
              TAX_: 'totalTax',
              PURCHASER_REGISTER_NUM_: 'purchaserRegisterNum',
              INVOICE_DATE_: 'invoiceDate',
              REMARK_: 'remark'
            },
            childrenMappings: {
              NAME_: 'name',
              SPECS_: 'type',
              UNIT_: 'unit',
              QUANTITY_: 'num',
              PRICE_: 'price',
              TAX_RATE_: 'taxRate',
              TAX_: 'tax',
              MONEY_: 'amount'
            }
          };
        }
        this.ocrInvoiceVisible = true;
      } else {
        console.log('-edit-table-handlerTopBarClick--其他----');
      }
    },
    handleBeforeUpload (file) {
      this.readFile(file);
    },
    // 读取文件
    readFile (file) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadstart = e => {
        this.uploadLoading = true;
        this.tableLoading = true;
        this.showProgress = true;
      };
      reader.onprogress = e => {
        this.progressPercent = Math.round(e.loaded / e.total * 100);
      };
      reader.onerror = e => {
        this.util.error('文件读取出错');
      };
      reader.onload = e => {
        this.util.success('文件读取成功');
        const data = e.target.result;
        const { header, results } = excel.read(data, 'array')[0];
        this.excelData = results;
        this.uploadLoading = false;
      };
    },
    handleUploadFile () {
      this.file = null;
    },
    downloadExecl (edit) {
      this.excelModal = edit;
    },
    // 选择导入文件确认事件
    selectExcel () {
      let hideList=['t_fly_check_score','t_system_check_score'];
      if(hideList.indexOf(this.config.formKey)>=0){
        //特定表单导入前清空明细数据
        this.config.tableData=[];
      }
      let modal = {};
      if (this.excelModal) {
        modal = this.excelModal;
      } else {
        modal = this.excelList[0];
      }
      if (modal && modal.children && this.excelData) {
        if (this.config.tableData === undefined) {
          this.config.tableData = [];
        }
        let data = [];
        this.excelData.forEach(row => {
          let ele = {};
          modal.children.forEach(edit => {
            ele[edit.columnName + 'isShow'] = false;
            ele[edit.columnName] = row[edit.excelName];
            // 如果字段唯一 并删除重复数据
            if (edit.isOnly == 1) {
              this.config.tableData = this.config.tableData.filter(item => {
                return item[edit.columnName] !== row[edit.excelName];
              });
            }
          });
          data.push(ele);
        });
        // 删除最后一行空数据
        if (this.config.tableData.length > 0) {
          let row = this.config.tableData[this.config.tableData.length - 1];
          let flag = true;
          for (const key in row) {
            if (row[key]) {
              flag = false;
            }
          }
          if (flag) {
            this.config.tableData.splice(this.config.tableData.length - 1, 1);
          }
        }
        // 导入添加排序
        let sort = this.config.tableData.length;
        let errorData = [];
        data.forEach((item,index) => {
          item.SORT_ = sort++;
          item.errorColumn = [];
          item.index = index;
          this.columns.forEach(column => {
            item[column.columnName + 'isShow'] = false;
            if (item[column.columnName] === undefined) {
              item[column.columnName] = undefined;
            }
            if (column.widgetType && column.widgetType === 'select-form') {
              if (item[column.columnName + 'LABEL_'] === undefined) {
                item[column.columnName + 'LABEL_'] = item[column.columnName];
              }
            }else if(column.widgetType && column.widgetType === 'select-date') {
              let v = item[column.columnName];
              // console.log('----v-----',v,typeof v, item);
              if(typeof v === 'object'){
                try{
                  var d=new Date(v);
                  v = d.format("yyyy-MM-dd");
                  item[column.columnName] = v;
                  item[column.columnName+'LABEL_'] = v;
                }catch(e){
                  item[column.columnName] = v;
                }
              }else{
                item[column.columnName] = v;
              }
            }
            try{
              // 触发子表运算
              item = this._handlerChangeValue('', column, item, sort, true,true);
            }catch(err){
              item.error=true;
              item.errorColumn.push(column.columnName);//错误字段
            }
          });
          if(item.error){
            errorData.push(item);
          }else{
            this.config.tableData.push(item);
          }
        });
        if(errorData.length>0){
          this.importErrorMsg=`一共识别到${data.length}行，成功${data.length-errorData.length}行，错误${errorData.length}行，具体错误如下:`;
          errorData.forEach(item=>{
            let errorArr=[];
            item.errorColumn.forEach(obj=>{
              if(item[obj]){
                errorArr.push(item[obj]);
              }
            });
            item.errorMsg=errorArr.join(",");
          });
          this.importErrorData=errorData;
        }else{
          this.selectExcelVisible=false;
        }
      }
      this.computePageData(this.pageIndex);

      // 触发汇总合计
      this._handlerSummaryChange();
      this.selectExcelVisible = false;
    },
    handlerGridOpenSelectForm (column, row, index) { // 单元格编辑打开表单
      // console.info('----handlerGridOpenSelectForm---')
      // console.log(column, row, index)
      this.queryParams = this.config.parent.getData().mainFormDataMap;
      this.selectTableRow = row;
      this.selectFormColumn = column;
      this.selectTableIndex = index;
      this.selectFormKey = column.attr;
      this.require = column.require;
      this.validMessage = column.validMessage;
      this.openDialogWidth = 900;
      this.openDialogHeight = 600;
      let formConfig = {};
      getConfig(this.selectFormKey, this).then(data => {
        for (var key in data) {
          formConfig[key] = data[key];
        }
        if (formConfig) {
          this.selectFormTitle = formConfig.title;
          // console.info('------this.selectFormTitle-------'+this.selectFormTitle)
        }
      });
      this.selectFormConfig = {};
      this.selectFormSingleSelect = true;
      this.selectFormVisible = true;
    },
    format (format, value) {
      if (typeof value === 'number') {
        let date = new Date(value);
        return date.format(format);
      } else if (typeof value === 'string') {
        if (value.indexOf('T') > -1) {
          return value.substring(0, 10);
        } else {
          try {
            if (value.indexOf(':') > -1) {
              return value;
            } else {
              let num = Number(value);
              let date = new Date(num);
              return date.format(format);
            }
          } catch (e) {
            return value;
          }
        }
      } else if (typeof value === 'object') {
        return value.format(format);
      }
    },
    formatDateFun (column, value) { // 格式化日期
      let format = 'yyyy-MM-dd';
      if (column.dateType === 'year') {
        format = 'yyyy';
      } else if (column.dateType === 'month') {
        format = 'yyyy-MM';
      } else if (column.dateType === 'datetime' || column.widgetType == 'select-date-time') {
        format = 'yyyy-MM-dd hh:mm:ss';
      } else if (column.widgetType == 'select-time') {
        format = 'hh:mm:ss';
      }
      if (typeof value === 'object') {
        return value.format(format);
      } else if (typeof value === 'number') {
        let date = new Date(value);
        return date.format(format);
      } else if (typeof value === 'string') {
        if (value.indexOf('T') > -1) {
          return value.substring(0, 10);
        } else {
          try {
            // console.log('---formatDateFun---',value)
            if (value.indexOf(':') > -1 || value.indexOf('-') > -1) {
              return value;
            } else {
              let num = Number(value);
              let date = new Date(num);
              return date.format(format);
            }
          } catch (e) {
            console.log('---formatDateFun--e--', e);
            return value;
          }
        }
      }
    },
    handlerSubFormUpload (column, row) { // 明细表上传附件
      let id = row['ID_'];
      this.uploadDialogConfig = {
        column, row, name: column.columnName
      };
      let attr = column.attr;
      let config = {xtype: column.columnName, id: id, autoLoad: true};
      // 加载数据字典
      if (this.validUtil.isNotNull(attr)) {
        let attrObj = JSON.parse(attr);
        config = {...config, ...attrObj};
      }
      // console.log('--------------')
      this.uploadDialogConfig.filesList = row[column.columnName + 'filesList'] || [];
      this.uploadDialogConfig.deleteFilesList = row[column.columnName + 'deleteFilesList'] || [];
      this.uploadDialogConfig.config = config;

      this.uploadDialogVisible = true;
    },
    handlerUploadDialogCondirm () { // 明细表上传附件确认
      // console.log(this.uploadDialogConfig.column.columnName + '--------handlerUploadDialogCondirm--------', this.uploadDialogConfig.row)
      let filesList = this.$refs['upload-dialog'].getFilesList();
      let deleteFilesList = this.$refs['upload-dialog'].getDeleteFilesList();
      // console.log('--------handlerUploadDialogCondirm--------', filesList, deleteFilesList)
      this.uploadDialogConfig.row[this.uploadDialogConfig.column.columnName + 'filesList'] = filesList;
      this.uploadDialogConfig.row[this.uploadDialogConfig.column.columnName + 'deleteFilesList'] = deleteFilesList;
      // console.log(this.config.tableData)
      this.uploadDialogVisible = false;
    },
    handlerChangeValue (newVal, column, row, index) { // 用户行为触发，监听字段值发生改变
      // console.log('------subForm--------handlerChangeValue---------',column.columnName,newVal)
      this.ifFormEditRender = false;
      // 修改父组件表单中修改editFormRender的状态
      if (this.config.parent && this.config.parent.handlerUpdateFormEditRenderStatus) {
        this.config.parent.handlerUpdateFormEditRenderStatus();
      }
      this._handlerChangeValue(newVal, column, row, index, false,false);
    },
    _handlerChangeValue (newVal, column, row, index, isImport,isBatch) { // 表单中字段变化，触发内部计算
      // console.log(column.columnName + '------subForm--------_handlerChangeValue---------',this.ifFormEditRender,column.columnName, index,newVal)
      // this.$refs[column.columnName + index][0].focus();
      // console.info(column.columnName+'--'+column.widgetType+'--'+newVal)
      // 改变时间日期值
      if (column && newVal && (column.widgetType == 'select-date' || column.widgetType == 'select-time' || column.widgetType == 'select-date-time')) {
        let value = this.formatDateFun(column, newVal);

        // console.log(newVal+'----'+column.columnName+'-----',(typeof newVal))

        this.$set(row, column.columnName, value);
        /* if(this.validUtil.isNull(row[column.columnName + 'LABEL_'])){
          this.$set(row, column.columnName + 'LABEL_', value)
        } */
        this.$set(row, column.columnName + 'LABEL_', value);
      }
      // console.log(column.columnName + '----------handlerChangeValue-------------', newVal, column, row, index)

      // console.info(row);
      // 循环计算公式
      if (column && this.expression && this.expression[column.columnName]) {
        let expressionConfig = this.expression[column.columnName];
        this._executeExpression(expressionConfig, row, index, isImport);
      }

      // 如果不是多选
      if (column && !(column.multiple === 1 && (column.widgetType === 'select' || column.widgetType === 'select-sql' || column.widgetType === 'select-dic'))) {
        row[column.columnName + 'isShow'] = false;
      }
      if (column && column.widgetType === 'switch') {
        row[column.columnName] = newVal === 'true' ? 1 : 0;
      }
      // 如果是下拉框
      if (column && (column.widgetType === 'select' || column.widgetType === 'select-sql' || column.widgetType === 'select-dic')) {
        // 如果是UID_ 或者ID结尾
        if (column.columnName && column.columnName.lastIndexOf('UID_') > -1) {
          let name = column.columnName.split('UID_');
          row[name[0] + 'NAME_'] = this.dicValue(column, newVal);
        }
        if (column.columnName && column.columnName.lastIndexOf('ID_') > -1) {
          let name = column.columnName.split('ID_');
          row[name[0] + 'NAME_'] = this.dicValue(column, newVal);
        }
        let name = this.dicValue(column, newVal);
        if (name) {
          let valueObj = {
            name: name,
            value: newVal
          };
          // console.log(newVal+'-------11111------',JSON.stringify(valueObj),this.dicValue(column, newVal))
          if (column.attr && column.attr.indexOf('backFillRule') > -1) {
            let attrObj = JSON.parse(column.attr);
            let backFillRule = attrObj.backFillRule;
            for (let key in backFillRule) {
              row[key] = valueObj[backFillRule[key]];
            }
          }
        }
      }
      // console.log(this.config.isTree+'-------'+column.columnName+'------',this.summaryColumns[column.columnName]);
      // 判断如果是树表，且有合计，则要向上统计
      if (this.config.isTree) {
        let columnConfig = this.summaryColumns[column.columnName];
        if (columnConfig) {
          // 递归向上计算
          this.deepUpSummary(column, row);
        }
      }
      // 说明是初始化加载，初始化加载，不需要每次都触发合计，否则会导致页面卡死
      if(isBatch == undefined || isBatch == false){
        // 触发汇总合计
        setTimeout(() => {
          // 触发调用
          this._handlerSummaryChange();
        }, 10);
      }
      return row;
    },
    _executeExpression (expressionConfig, row, index, isImport) { // 执行表达式
      // console.log('-----_executeExpression-----',expressionConfig, row, index, isImport);
      for (let desColumnName in expressionConfig) {
        let desColumn = this.columnsMap[desColumnName];
        let expressionStr = expressionConfig[desColumnName].expression;
        let keys = expressionConfig[desColumnName].keys;
        // 主表的keys,参与计算的字段中文
        let mainKeys = expressionConfig[desColumnName].mainKeys;
        // console.log(desColumnName + '----------------', expressionConfig[desColumnName],expressionStr);
        if (desColumn && keys) {
          var expression = '';
          keys.forEach(key => {
            let col = this.columnsMap[key];
            if (col) {
              if (col.javaType === 'Double' || col.javaType === 'Integer') {
                if (row[col.columnName] === undefined || row[col.columnName] === '') {
                  expression += 'var ' + col.columnName + ' = 0 ;';
                } else {
                  expression += 'var ' + col.columnName + ' = ' + row[col.columnName] + ' ;';
                }
              } else {
                if (row[col.columnName] === undefined) {
                  expression += 'var ' + col.columnName + ' = "" ;';
                } else {
                  expression += 'var ' + col.columnName + ' = "' + row[col.columnName] + '" ;';
                }
              }
            }
          });
          if (mainKeys) {
            mainKeys.forEach(item => {
              let columnTitle = item.columnTitle;
              let key = item.key;
              if (this.config.parent && this.config.parent.getValByColumnTitle) {
                let val = this.config.parent.getValByColumnTitle(columnTitle);
                // console.log(columnTitle + '-------' + val + '==')
                if (val == null) {
                  val = 0;
                }
                expressionStr = expressionStr.replace(key, val);
              }
            });
          }
          var _this = this;
          // console.info('----expressionStr---' + expressionStr, FUN_DATA)
          for (let funType in FUN_DATA) {
            // console.log(funType + '-----' + expressionStr.indexOf(funType + '.'))
            if (expressionStr.indexOf(funType + '.') > -1) {
              expressionStr = funUtil.replaceStr(funType, expressionStr);
            }
          }
          if (expressionStr.indexOf('dateUtil.') > -1) {
            expressionStr = expressionStr.replaceAll('dateUtil.', '_this.dateUtil.');
          }
          if (expressionStr.indexOf('mathUtil.') > -1) {
            expressionStr = expressionStr.replaceAll('mathUtil.', '_this.mathUtil.');
          }
          // console.log('------expressionStr------'+expressionStr);
          if (expressionStr.length > 0) {
            var expression_result = 0;
            // console.info(key+'-------'+this.expression[key])
            var resultStr = expression + ' expression_result = ' + expressionStr + ';';
            // console.log('----resultStr----', isImport, resultStr, desColumn, this.ifFormEditRender)
            eval(resultStr);
            // console.log(desColumn, desColumnName + '---( ' + expressionConfig[desColumnName].expression + ' )-------' + expression_result + '--------resultStr-----' + resultStr)
            // eslint-disable-next-line camelcase
            // this.mainData[desColumnName] = result
            // console.log(isImport +'-------',!this.ifFormEditRender,(this.ifFormEditRender && desColumn && desColumn.silence && desColumn === 1))
            // 如果不是编辑时第一次渲染，或者编辑时第一次渲染，但是时静默类型，则就每次都计算
            if (isImport || !this.ifFormEditRender || (this.ifFormEditRender && desColumn && desColumn.silence === 1)) {
              if (desColumn.javaType && (desColumn.javaType === 'Float' || desColumn.javaType === 'Double')) {
                row[desColumnName] = expression_result === undefined ? 0 : this.toFixed(expression_result);
              } else {
                if (desColumn.javaType === 'Date') {
                  if (this.validUtil.isNotNull(expression_result)) {
                    row[desColumnName] = new Date(expression_result);
                  } else {
                    row[desColumnName] = '';
                  }
                } else {
                  row[desColumnName] = expression_result;
                }
              }
              this.$forceUpdate();

              if (desColumn) {
                // console.log(desColumnName,'------------desColumnName----------',row[desColumnName], desColumn, row, index)
                // return2
                // 继续触发值的修改
                this._handlerChangeValue(row[desColumnName], desColumn, row, index, isImport,isImport);
              }
            }
          }
        }
      }
    },

    handlerMainDataChange (column, value) { // 主表字段数据变化时触发
      let columnTitle = column.title;
      // console.log(columnTitle+'----handlerMainDataChange---'+value,column)
      let mainExpression = this.mainExpression[columnTitle];
      // console.log(columnTitle+'----handlerMainDataChange---'+value,column,mainExpression)
      if (mainExpression) {
        // 循环明细表数据，执行表达式
        if (this.config.tableData && this.config.tableData.length >= 0) {
          this.config.tableData.forEach((row, index) => {
            this._executeExpression(mainExpression, row, index, true);
          });
        }
      }
      // 调用显示隐藏控制计算
      this.computeShowConditionConfig(columnTitle);
    },
    deepUpSummary (column, row) { // 递归向上合计
      // 如果父亲是根节点，则不需要统计，控件会自动计算
      if (row['parentId'] && row['parentId'] !== this.config.rootId) {
        let parentNode = this.getParentNode(this.config.tableData, row['parentId']);
        // console.log(row['parentId']+'---deepUpSummary---',row,parentNode,this.config.tableData);
        if (parentNode) {
          let summary = 0;
          const values = parentNode['children'].map(item => {
            let val = item[column.columnName];
            val = Number(val);
            return val;
          });
          if (!values.every(value => isNaN(value))) {
            // console.info('---------')
            let result = values.reduce((prev, curr) => {
              // console.info(prev+'--------'+curr)
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            summary = this.toFixed(result);
            // console.log(result, '----deepUpSummary----', summary);
          } else {
            summary = 0;
          }
          parentNode[column.columnName] = summary;
          // console.log(column.columnName+'-------deepUpSummary---------',row, parentNode, summary)
          // 递归向上计算
          this.deepUpSummary(column, parentNode);
          this.$forceUpdate();
        }
      }
    },
    toFixed (num) {

      let m;
      try {
        m = num.toString().split('.')[1].length;
      } catch (e) {
        m = 0;
      }
      var times = Math.pow(10, m);
      var des = 0;
      if (num > 0) {
        des = num * times + 0.5;
      } else {
        des = num * times - 0.5;
      }
      des = parseInt(des, 10) / times;
      //console.log(des+"====toFixed====",des.toFixed(this.sessionUtil.getDecimalDigit()));
      let s = des+'';
      if(s.indexOf('.')>-1){
        // 判断小数位
        let digit = s.substring(s.lastIndexOf('.')+1).length;
        //console.log(digit+"====toFixed==1111==",this.sessionUtil.getDecimalDigit());
        if(digit >= 3 && this.sessionUtil.getDecimalDigit() === 3){
          return des.toFixed(3);
        }else{
          return des.toFixed(2);
        }
      }else{

        return des;
      }

    },
    deepPackTreeData (data, parentId) { // 弹框选择回填confirmSelect时如果是树表回填，则需要把回填的数据中id和parentId替换掉
      let vm = this;
      data.forEach(item => {
        vm.columns.forEach(column => {
          item[column.columnName + 'isShow'] = false;
          if (item[column.columnName] === undefined) {
            item[column.columnName] = undefined;
          }
          if (column.widgetType && column.widgetType === 'select-form') {
            if (item[column.columnName + 'LABEL_'] === undefined) {
              item[column.columnName + 'LABEL_'] = item[column.columnName];
            }
          } else if (column.widgetType && column.widgetType === 'select-date') {
            if (item[column.columnName + 'LABEL_'] === undefined) {
              item[column.columnName + 'LABEL_'] = this.util.format('yyyy-MM-dd', item[column.columnName]);
            }
          }
          item = this._handlerChangeValue('', column, item, 0, true,true);
        });

        item.id = getUUID();
        item.parentId = parentId;

        // 递归修改下级
        if (item.children && item.children.length > 0) {
          this.deepPackTreeData(item.children, item.id);
        }
      });
    },
    deepMerge (data, parentId,oldData) { // 弹框选择回填confirmSelect时如果是树表回填，则需要把回填的数据中id和parentId替换掉,并且根据唯一列合并
      // 默认根据编码唯一
      let uniqueColumns = [{columnName:'CODE_'}];

      let vm = this;
      data.forEach(item => {
        let find = oldData.find(old=>{
          let newVal = '';
          let oldVal = '';
          uniqueColumns.forEach(c=>{
            let columnName = c.columnName;
            newVal = newVal + (item[columnName]?item[columnName]:'');
            oldVal = oldVal + (old[columnName]?old[columnName]:'');
          });
          // console.log(newVal+'--------'+oldVal);
          return newVal === oldVal;
        });
        //console.log('--------',item,find);
        // 如果历史中有该数据
        if(find){
          // 则要比对下一级
          parentId = find.id;
          // 递归修改下级
          if (item.children && item.children.length > 0) {
            this.deepMerge(item.children, parentId,find.children);
          }
        }else{
          item.parentId = parentId;
          oldData.push(item);
        }
      });
    },
    confirmSelect (row) { // 弹框选择确定数据
      // console.info('----------confirmSelect-----------'+this.formSelectBindColumn);
      let vm = this;
      let selectedData = [];
      let selectForm = this.$refs['select-form'];
      if (selectForm && selectForm.getSelectedData) {
        // console.info('---------------------'+selectForm.getSelectedData)
        selectedData = selectForm.getSelectedData();
      }
      let tableData = this.config.tableData;
      if (!tableData) {
        this.config.tableData = [];
        tableData = this.config.tableData;
      }
      // console.log('----------confirmSelect-----------',this.selectFormSingleSelect,selectedData,this.formSelectBindColumn);
      if (this.selectFormSingleSelect) {
        // 说明是行内弹框，只能选择一条数据
        if (selectedData.length !== 1) {
          this.util.warn('请选择一行数据');
          return;
        }
        // 判断是否在行中点击弹出
        if (this.selectTableIndex > -1) {
          let item = selectedData[0];
          // 把第一行数据赋值给数组
          let row = this.isTree ? this.getCurrentRow() : tableData[this.selectTableIndex];
          this.columns.forEach(column => {
            // 触发子表运算
            row = this._handlerChangeValue('', column, row, this.selectTableIndex, true);
            let key = column.columnName;
            if (item[key] !== undefined) {
              row[key] = item[key];
              if (column.widgetType == 'select-date' || column.widgetType == 'select-time' || column.widgetType == 'select-date-time') {
                let value = this.formatDateFun(column, row[key]);
                row[column.columnName + 'LABEL_'] = value;
              }
            } else {
              if (row[key] === undefined) {
                row[key] = undefined;
              }
            }
            if (column.multiple == 1 && (column.widgetType == 'select' || column.widgetType == 'select-dic' || column.widgetType == 'select-sql')) {
              if (item[key]) {
                row[key] = item[key].split(',');
              } else {
                row[key] = null;
              }
            }
            if (column.widgetType && column.widgetType === 'select-form') {
              if (item[key + 'LABEL_']) {
                row[key + 'LABEL_'] = item[key + 'LABEL_'];
              } else {
                row[key + 'LABEL_'] = item[key];
              }
            }
            row[column.columnName + 'isShow'] = false;
          });
        }
      } else {
        if (selectedData.length === 0) {
          this.util.warn('请选择数据');
          return;
        }
        // 判断是否树表
        if (this.config.isTree) {
          // 只获取弹框中根节点下的树数据
          // console.log('--------selectForm----------',selectForm)
          selectedData = selectForm.getSelectedTreeData();
          //console.log('------弹框获取到数据--------',tableData, selectedData)
          // 判断选择回填之前是否已经有一行空行，如果是回填之后删除
          if(tableData && tableData.length == 1){
            let first = tableData[0];
            let empty = true;
            this.columns.forEach(column => {
              let key = column.columnName;
              // console.log(key+'-------'+first[key]);
              if(this.validUtil.isNotNull(first[key])){
                empty = false;
              }
            });
            //console.log('-----empty---',empty);
            if(empty){
              tableData.shift();
            }
          }
          //console.log('---tableData----',tableData);
          // 递归重新组装数据
          vm.deepPackTreeData(selectedData, this.config.rootId);

          // 同原有数据合并
          vm.deepMerge(selectedData,this.config.rootId,tableData);
          //console.log('------弹框处理后结果--------', tableData)
          vm.config.tableData = tableData;
          vm.dataList = tableData;
          // 触发汇总合计
          this._handlerSummaryChange();

          this.$forceUpdate();
          this.selectFormVisible = false;

          return;
        }

        let insertData = [];
        // 判断第一条数据是否为空 为空删除
        let flag = true;
        vm.columns.forEach(column => {
          if (vm.config.tableData && vm.config.tableData.length > 0) {
            let value = vm.config.tableData[vm.config.tableData.length - 1][column.columnName];
            if (value != undefined && value != '') {
              flag = false;
            }
          } else {
            if (!vm.config.tableData) {
              vm.config.tableData = [];
            }
          }
        });
        if (flag) {
          vm.deleteRow(vm.config.tableData.length - 1, vm.config.tableData[vm.config.tableData.length - 1], vm.config.tableData);
        }
        // 获取当前所有行
        let rowCount = tableData.length;
        // 遍历带插入的数据
        // console.log('------------confirmSelect----------',selectedData)
        selectedData.forEach(item => {
          let row = {};
          if (!this.config.isTree) {
            row.id = getUUID();
          }
          this.columns.forEach(column => {
            let key = column.columnName;
            // console.log(key+'-------'+item[key])
            if (item[key] !== undefined) {
              row[key] = item[key];
              if (column.widgetType == 'select-date' || column.widgetType == 'select-time' || column.widgetType == 'select-date-time') {
                let value = this.formatDateFun(column, row[key]);
                row[column.columnName + 'LABEL_'] = value;
              }
            } else {
              if (row[key] === undefined) {
                row[key] = undefined;
              }
            }
            if (column.widgetType && (column.widgetType === 'select-form' || column.widgetType === 'select-user' || column.widgetType === 'select-user-list' || column.widgetType === 'select-user-multi')) {
              if (item[key + 'LABEL_'] !== undefined) {
                row[key + 'LABEL_'] = item[key + 'LABEL_'];
              } else {
                row[key + 'LABEL_'] = item[key];
              }
            }
            if (column.multiple == 1 && (column.widgetType == 'select' || column.widgetType == 'select-dic' || column.widgetType == 'select-sql')) {
              if (item[key]) {
                row[key] = item[key].split(',');
              } else {
                row[key] = null;
              }
            }else if (column.widgetType && column.widgetType === 'select-data') {
              // 行数据下拉
              let options = [];
              let dicStr = item[key];
              if(this.validUtil.isNotNull(dicStr)){
                let dicArr = dicStr.split(',');
                dicArr.forEach(d=>{
                  options.push({
                    name: d,
                    value:d,
                    disabled:false
                  });
                });
              }
              if(!row.options){
                row.options = {};
              }
              if(options.length>0){
                row[key] = options[0].value;
                row[key + 'LABEL_'] = options[0].name;
              }else{
                row[key] = null;
                row[key + 'LABEL_'] = '';
              }
              // console.log('-----options---',options);
              row.options[column.columnName] = options;
            }
            row[column.columnName + 'isShow'] = false;
            if(this.onlyMainExpression[column.columnName]){
              rowCount = rowCount + 1;
              let expressionConfig = {};
              expressionConfig[column.columnName ] = this.onlyMainExpression[column.columnName];
              this._executeExpression (expressionConfig, row, rowCount, true);
            }else {
              // 触发子表运算
              row = this._handlerChangeValue(row[key], column, row, 0, true, true);
            }
          });
          if (this.subFormConfig) {
            row.subFormConfig = {...this.subFormConfig};
            row.subFormConfig.parentRow = row;
            row.subFormConfig.parent = this.config.parent;
            row.subFormConfig.parentCmp = this;
          }
          insertData.push(row);
        });
        // console.log('-------confirmSelect------', insertData)
        if (insertData.length > 0) {
          // 再表格的下一行插入数据
          tableData = tableData.concat(insertData);
        }
      }
      this.config.tableData = tableData;
      // console.log('------confirmSelect----selectedData---',selectedData)
      // console.info(this.config.tableData)

      // 重新分页数据
      this.computePageData(this.pageIndex);

      // 触发汇总合计
      this._handlerSummaryChange();

      this.$forceUpdate();

      // console.log(this.tableData)
      // console.info(this.tableData)
      // console.info(selectedData);
      // console.info(selectedData);
      this.selectFormVisible = false;
    },
    iptBlur (row, column, index) {
      // this.clickRow = row;
      setTimeout(() => {
        this.$set(row, column.columnName + 'isShow', false);
      }, 150);
    },
    getSummaries (param) {
      // console.info('--------getSummaries-------', param)
      const { columns, data2 } = param;
      const data = this.config.tableData || [];
      const sums = [];
      let _this = this;
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '合计';
          return;
        }
        // console.info(column.columnName+'-----------'+column.property)
        // console.info(_this.summaryColumns)
        // console.info(column)
        let property = column.property ? column.property : column.columnName;
        let columnConfig = _this.summaryColumns[property];
        if (columnConfig) {
          let title = columnConfig.fullTitle || columnConfig.title;
          // console.log('------title------',columnConfig)
          // console.info(columnConfig)
          const values = data.map(item => {
            // console.info(property+'-----'+JSON.stringify(item))
            let val = item[property];
            // console.info('1--------'+val);
            val = Number(val);
            // console.info('2--------'+val);
            return val;
          });
          // console.info(values)
          if (!values.every(value => isNaN(value))) {
            let result = 0;
            values.forEach(curr => {
              const value = Number(curr);
              // console.info(result+'--------'+curr, value,(140000+134093.79),(result + value))
              if (!isNaN(value)) {
                result = this.util.numAdd(result, value);
              }
            });
            // console.info('---------')
            /* let result = values.reduce((prev, curr) => {
               else {
                return prev
              }
            }, 0) */
            // console.info('result---' + result)
            // 解决合计精度丢失问题
            result = result === undefined ? 0 : this.toFixed(result);
            sums[index] = result;
            if (columnConfig.widgetType === 'number-permil') {
              sums[index] = this.util.numToPermil(result);
            }
            _this.summaryData[title] = result;
            // sums[index] += ' 元';
          } else {
            sums[index] = '';
            _this.summaryData[title] = 0;
          }
        } else {
          sums[index] = '';
        }
      });
      // console.info(_this.summaryData)
      // console.info(sums)
      // console.log('-----sums----', sums, this.summaryData) // ON.stringify(sums))
      // this.$forceUpdate()
      /* setTimeout(()=>{

        // 触发调用
        this._handlerSummaryChange()
      },100) */
      // this.$refs['jr-table'].doLayout()
      // console.log(sums)
      return sums;
    },
    getSummaryData () { // 获取汇总数据
      // console.log('------getSummaryData----',this.config.tableData,this.config,this.summaryColumns,this.summaryData)
      // 判断是否有些合计列是隐藏，导致合计数据为空
      if (this.summaryColumns) {
        let data = this.config.tableData;
        let _this = this;
        for (let key in this.summaryColumns) {
          let column = this.summaryColumns[key];
          // 如果是多层则要根据完整标题计算
          let title = column.fullTitle || column.title;
          // console.log('-----title-----',title,column.fullTitle,column)
          let property = column.columnName;
          // console.log(title+'------'+property,data)
          if (true) {
            //  if (column.hidden && column.hidden === 1) {
            const values = data.map(item => {
              // console.info(property+'-----'+JSON.stringify(item))
              let val = item[property];
              //console.info(title+'----'+property+'----'+val);
              val = Number(val);
              // console.info('2--------'+val);
              return val;
            });
            //console.info(values)
            if (!values.every(value => isNaN(value))) {
              // console.info('---------')
              let result = values.reduce((prev, curr) => {
                // console.info(prev+'--------'+curr)
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.util.numAdd(prev, value);
                } else {
                  return prev;
                }
              }, 0);
              // console.info('result---'+result)
              // 解决合计精度丢失问题
              result = result === undefined ? 0 : this.toFixed(result);
              _this.summaryData[title] = result;
              // sums[index] += ' 元';
            } else {
              _this.summaryData[title] = 0;
            }
          }
        }
      }
      //console.log('----summaryData---',this.summaryData)
      return this.summaryData;
    },
    handleRowButtonClick (column, index, row) { // 列表中按钮
      if (column.events) {
        eval(column.events);
      }
      if (column.openType && column.openUrl) {
        let openParams = column.openParams;
        // console.info('openParams--1--'+openParams)
        if (openParams) {
          for (let key in row) {
            if (openParams.indexOf('{' + key + '}') > -1) {
              let value = row[key] ? row[key] : '';
              openParams = openParams.replace(new RegExp('{' + key + '}', 'gm'), value);
            }
          }
          // 判断是否还有参数不存在无法替换
          if (openParams.indexOf('{') > -1 && openParams.indexOf('}') > -1) {
            let keys = openParams.match(/\"\{(.*?)\}\"/gi); // 匹配所有类似{}的变量
            if (keys) {
              keys.forEach(key => {
                // let columnName = key.trim().substring(key.indexOf('[')+1,key.indexOf(']'))
                openParams = openParams.replace(new RegExp(key, 'gm'), '""');
              });
            }
          }
        }
        // console.info('openParams--2--'+openParams)
        if (openParams.title) {
          this.openDialogTitle = openParams.title;
        } else {
          this.openDialogTitle = column.title;
        }
        this.openDialogWidth = column.openWidth ? column.openWidth : 900;
        this.openDialogHeight = column.openHeight ? column.openHeight : 600;
        // console.info( this.openDialogWidth+'---------'+openParams.title+'---------'+this.openDialogHeight)
        if (column.openType === 2) {
          // console.info(column.openType+'---------'+column.openUrl+'---------'+openParams)
          this.openByName(column.openUrl, openParams);
          // this.$router.push({
          //   name: 'form-view',
          //   params: {
          //     formKey:'project-info',
          //     title:'项目信息'
          //   }
          // })
        } else if (column.openType === 1) {
          // console.info(column)
          // console.info(this.$route)
          // console.info(openParams)
          this.openDialogVueName = column.openUrl;
          let params = null;
          if (this.openDialogVueName === 'form-query' || this.openDialogVueName === 'form-view') {
            this.showOpenDialogTitle = false;
            params = typeof openParams === 'string' ? JSON.parse(openParams) : openParams;
            params.selectFormKey = params.formKey;
            params.openConfig = {};
            if (params.title) {
              this.openDialogTitle = params.title;
            }
          } else {
            this.showOpenDialogTitle = true;
            params = {
              openConfig: typeof openParams === 'string' ? JSON.parse(openParams) : openParams
            };
            if (params.openConfig.title) {
              this.openDialogTitle = params.openConfig.title;
            }
          }

          // console.info(params)
          let route = this.getRouteConfigByName(column.openUrl);
          this.openDialogVisible = true;
          // 因为是表单所以通过这种方式传参
          params.openConfig.parent = this;
          this.openDialogConfig = {
            route, params
          };
        }
      } else {
        // 判断是否按钮触发调用
        if (column.sourceType === 'api' && column.sourceAttr) {
          // console.info('--------')
          let _this = this;
          let apiConfig = column.apiConfig;
          if (apiConfig) {
            let params = {};
            if (apiConfig.children) {
              apiConfig.children.forEach(child => {
                let key = null;
                for (let field in row) {
                  if (child.value === '{' + field + '}') {
                    key = field;
                    break;
                  }
                }

                if (key) {
                  params[child.code] = row[key];
                } else {
                  params[child.code] = child.value;
                }
              });
            }
            // 获取sql中需要传入后台的参数
            if (apiConfig.runsql) {
              let runsql = apiConfig.runsql;
              for (let field in row) {
                let key = null;
                if (runsql.indexOf('{' + field + '}') > -1) {
                  key = field;
                }
                if (key && row[key]) {
                  params[key] = row[key];
                }
              }
            }
            _this.util.mask('正在执行...');
            // 调用获取数据
            getDataByApi(apiConfig.id, params).then(res => {
              _this.loadData();
              _this.util.unmask();
              _this.util.success('执行成功!');
            }).catch(() => {
              _this.util.unmask();
            });
          }
        } else {
          // 发票识别
          console.log('----发票识别----');
        }
      }
      // console.info('22---------')
    },
    closeForm () {
      // 弹框的关闭和保存之后调用关闭
      this.openDialogVisible = false;
    },
    getRouteConfigByName (name) {
      // console.info(name)
      if (this.$router.options.routes) {
        // console.info(this.$router)
        let data = this.$router.options.routes.find(item => {
          return item.name === name;
        });
        // console.info(data)
        if (data) {
          if (data.length > 0) {
            return data[0];
          }
          return data;
        }
      }
      return null;
    },
    setFormWidth (formConfig) {
      this.selectFormConfig = formConfig;
    },
    openByName (name, params, query) {
      let route = {name: name};
      if (params) {
        route.params = JSON.parse(params);
      }
      if (query) {
        route.query = JSON.parse(query);
      }
      // console.info('--------111-------'+typeof params)
      // console.info(route)
      // console.info(params);
      // this.$router.push(route);
      this.$router.push({
        name: name,
        params: route.params
      });
    },
    _handlerSummaryChange () { // 获取汇总数据
      // console.info('-----handlerSummaryChange-----1---'+this.config.parent)
      if (this.config.parent && this.config.parent.handlerSummaryChange) {
        this.config.parent.handlerSummaryChange(this.config, this.getSummaryData());
      }
    },
    handlerOcrSuccess (row, uniqueColumnName) { // ocr识别结果
      // console.log('-----handlerOcrSuccess-------',row,uniqueColumnName)
      if (!row['id']) {
        row['id'] = getUUID();
      }
      if (this.subFormConfig && row.children) {
        row.subFormConfig = {...this.subFormConfig};

        row.subFormConfig.parent = this.config.parent;
        row.subFormConfig.parentCmp = this;
        row.subFormConfig.parentRow = row;

        // 递归组装初始化数据
        this.deepRenderData(row.children, false);
        // console.log('--------end-------',res.data)

        let config = row.subFormConfig;
        config.tableData = row.children;
        delete row.children;
      }

      // 查找是否已经存在
      let find;
      if (uniqueColumnName) {
        let v = row[uniqueColumnName[0]] + row[uniqueColumnName[1]];
        find = this.config.tableData.find(item => {
          return v === (item[uniqueColumnName[0]] + item[uniqueColumnName[1]]);
        });
      }
      // console.log('-----handlerOcrSuccess----33---',find)
      if (!find) {
        // console.log('-----handlerOcrSuccess---55----',find)
        this.addRow(this.config.tableData.length, row);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/form/edit-table/mixin.js